(function () {
  'use strict';

  angular.module('k9.pet.pop.create', [
    'ui.router'
  ])

  .controller('CreatePetPopController', function(BreedsModel,client,
                                                  ClientsModel,PetsModel,
                                                  $log, $state, $stateParams,
                                                  $mdDialog) {

    //Public
    var vm              =   this;
    vm.pet              =   PetsModel.getCurrentPet() ;
    vm.createPetCancel  =   createPetCancel;
    vm.createPet        =   createPet;
    vm.breeds           =   [];
    vm.isSaving         =   isSaving;

    // On Load
    getBreeds();

    //Private
    var saving = false;

    function isSaving(){
      return saving;
    }

    function getBreeds(){
      BreedsModel.getBreeds()
                 .then(function (breeds) {
                    vm.breeds = breeds;
                 });
    }

    function createPet(pet){

      saving = true;

      if(!client){
        //Create pet
        PetsModel.createPet(pet)
                 .then(function (pets) {
                   PetsModel.addPet(pets.data.dog);
                   saving = false;
                   $mdDialog.hide();
                 });
      }else{
        //Create pet and associate to owner
        PetsModel.createPetWithOwner(pet,client.id)
                 .then(function (pets) {
                   PetsModel.addPet(pets.data.dog);
                   ClientsModel.addDogLocally(pets.data.dog);
                   saving = false;
                   $mdDialog.hide();
                 });
      }

    }

    function createPetCancel(){
      $mdDialog.cancel();
    }

  }) // end create pet pop controller

  //Routes
  .config(function ($stateProvider) {

    //State Providers
    $stateProvider.state('k9.pet.pop.create',{
      url: '/pet/pop/create',
      views: {
                'main@' : {
                            controller: 'CreatePetPopController as vm',
                            templateUrl: 'app/pets/create/pop/pet-create-pop.tmpl.html'
                          }
             }
    });

  });

}()); // end use strict

(function() {
  'use strict';

  angular
    .module('k9', [
      'ngFileUpload',
      'ngAnimate',
      'ngCookies',
      'ngSanitize',
      'ngMessages',
      'ngAria',
      'ngResource',
      'ui.router',
      'ngMaterial',
      'ngMdIcons',
      'toastr',
      'k9.navigation',
      'k9.login',
      'k9.register',
      'ui.calendar',
      'k9.models.calendar_events',
      'k9.dashboard',
      'k9.appointment.create',
      'ui.router.title',
      'k9.models.clients',
      'k9.clients',
      'k9.clients.create',
      'k9.clients.view',
      'k9.clients.edit',
      'k9.models.pets',
      'k9.pets',
      'k9.pets.create',
      'k9.pets.edit',
      'k9.pet.pop.create',
      'k9.social',
      'k9.breeds',
      'k9.breeds.create',
      'k9.breeds.edit',
      'k9.breed.pop.create',
      'k9.models.breeds',
      'k9.profile',
      'k9.models.profiles',
      'k9.report',
      'k9.activities',
      'k9.activities.create',
      'k9.activities.edit',
      'k9.models.activities',
      'k9.models.photos',
      'k9.models.messages',
      'k9.settings',
      'ngMap'
    ]);

})();

// Directive - Client Thumbnail
(function() {
  'use strict';

  angular.module('k9')
    .directive('k9FullPageLoader', function() {
      return {
        restrict: 'E',
        templateUrl: 'app/common/directives/full-page-loader/fullpage-loader.tmpl.html'
      };
    });

}());

// Directive - Client Thumbnail
(function() {
  'use strict';

  angular.module('k9')
    .directive('k9ClientThumb', function() {
      return {
        restrict: 'E',
        templateUrl: 'app/common/directives/client-thumbnail/client-thumbnail.tmpl.html'
      };
    });

}());

(function () {
  'use strict';

  angular.module('k9.breed.pop.create', [
    'ui.router'
  ])

  .controller('CreateBreedPopController', function(client,ClientsModel,BreedsModel, $log, $state, $stateParams, $mdDialog) {

    //Public
    var vm = this;
    vm.breed              =   BreedsModel.getCurrentBreed() ;
    vm.createBreedCancel  =   createBreedCancel;
    vm.createBreed        =   createBreed;

    //Private
    function createBreed(breed){

      if(!client){
        //Create breed
        BreedsModel.createBreed(breed)
                 .then(function (breeds) {
                   BreedsModel.addBreed(breeds.data.dog);
                   $mdDialog.hide();
                 });
      }else{
        //Create breed and associate to owner
        BreedsModel.createBreedWithOwner(breed,client.id)
                 .then(function (breeds) {
                   BreedsModel.addBreed(breeds.data.dog);
                   ClientsModel.addDogLocally(breeds.data.dog);
                   $mdDialog.hide();
                 });
      }

    }

    function createBreedCancel(){
      $mdDialog.cancel();
    }

  }) // end create breed pop controller

  //Routes
  .config(function ($stateProvider) {

    //State Providers
    $stateProvider.state('k9.breed.pop.create',{
      url: '/breed/pop/create',
      views: {
                'main@' : {
                            controller: 'CreateBreedPopController as vm',
                            templateUrl: 'app/breeds/create/pop/breed-create-pop.tmpl.html'
                          }
             }
    });

  });

}()); // end use strict

(function () {
  'use strict';

  angular.module('k9.breed.pop.create', [
    'ui.router'
  ])

  .controller('CreateBreedPopController', function(client,ClientsModel,BreedsModel, $log, $state, $stateParams, $mdDialog) {

    //Public
    var vm = this;
    vm.breed              =   BreedsModel.getCurrentBreed() ;
    vm.createBreedCancel  =   createBreedCancel;
    vm.createBreed        =   createBreed;

    //Private
    function createBreed(breed){

      if(!client){
        //Create breed
        BreedsModel.createBreed(breed)
                 .then(function (breeds) {
                   BreedsModel.addBreed(breeds.data.dog);
                   $mdDialog.hide();
                 });
      }else{
        //Create breed and associate to owner
        BreedsModel.createBreedWithOwner(breed,client.id)
                 .then(function (breeds) {
                   BreedsModel.addBreed(breeds.data.dog);
                   ClientsModel.addDogLocally(breeds.data.dog);
                   $mdDialog.hide();
                 });
      }

    }

    function createBreedCancel(){
      $mdDialog.cancel();
    }

  }) // end create breed pop controller

  //Routes
  .config(function ($stateProvider) {

    //State Providers
    $stateProvider.state('k9.breed.pop.create',{
      url: '/breed/pop/create',
      views: {
                'main@' : {
                            controller: 'CreateBreedPopController as vm',
                            templateUrl: 'app/breeds/create/pop/breed-create-pop.tmpl.html'
                          }
             }
    });

  });

}()); // end use strict

(function () {
  'use strict';

  angular.module('k9.pets.edit', [
    'ui.router',
    'k9.models.pets'
  ])

  .controller('EditPetController', function ($window,PhotosModel,appConfig,Upload,BreedsModel,$state, $stateParams, ClientsModel, PetsModel,$mdDialog) {

      var vm                =   this;
      vm.breeds             =   [];
      vm.clickIcon          =   'menu'; //Menu Icon Animation
      vm.editedPet          =   PetsModel.getCurrentPet();
      vm.cancelEditing      =   cancelEditing;
      vm.updatePet          =   updatePet;
      vm.selectedPhoto      =   null;
      vm.selectPhoto        =   selectPhoto;
      vm.goBack             =   goBack;

      // Uploading
      vm.uploadingImage     =   false;
      vm.uploadPetImage     =   uploadPetImage;
      vm.removePetImage     =   removePetImage;
      vm.toggleUploadForm   =   toggleUploadForm;
      vm.isUploading        =   false;
      vm.uploadButtonText   =   '';
      vm.updatePhotoDetails = updatePhotoDetails;

      //Onload
      getBreeds();
      toggleUploadingState(false);

      // setTimeout(function(){
      //    vm.clickIcon = 'keyboard_backspace';
      // }, 1); //removed as on some devices takes too long to animate
      vm.clickIcon = 'keyboard_backspace';

      PetsModel.getPetById($stateParams.petID)
                  .then(function (pet) {
                      if (pet) {
                          PetsModel.setCurrentPet(pet);
                      } else {
                          returnToPets(true);
                      }
                  });

      // Private

      function goBack(){
         $window.history.back();
      }

      function updatePhotoDetails(photo){
        PhotosModel.save(photo)
                   .then(function updatePhotoDetailsSuccess(response) {
                       vm.selectedPhoto=null;
                    });
      }

      function selectPhoto(photo){
        vm.selectedPhoto = photo;
      }

      function toggleUploadingState(on){
        if(on){
          vm.isUploading = true;
          vm.uploadButtonText = 'Uploading. Please wait...';
        }else{
          vm.isUploading = false;
          vm.uploadButtonText = 'Upload Photo';
        }
      }

      function toggleUploadForm(show){
        vm.uploadingImage = show;
      }

      function removePetImage(photo){
        PhotosModel.delete(photo)
                   .then(function removePetImageSuccess(response) {
                      //Remove from in memory array
                      _.remove(vm.editedPet.photos, function(c) {
                        return c.id == photo.id;
                      });
                   });
      }

      function uploadPetImage(photo){
        toggleUploadingState(true);
        Upload.upload({
            url: appConfig.API.baseURL + 'photos',
            method: 'POST',
            data: {
                    'photo[source]'   : photo.file,
                    'photo[title]'    : photo.title,
                    'photo[taken_at]' : photo.dateTaken,
                    'dog_id'          : vm.editedPet.id
                  }
        }).then(function (resp) {
            // Set newly updated image to model
            vm.newphoto = null;
            vm.editedPet.photos.push(resp.data.photo);
            toggleUploadForm(false);
            toggleUploadingState(false);
        }, function (resp) {
            console.log('Error uploading pet image. Status: ' + resp.status);
            toggleUploadingState(false);
        }, function (evt) {
            var progressPercentage = parseInt(100.0 * evt.loaded / evt.total);
            console.log('Upload Progress: ' + progressPercentage + '% ');
       });

      }

      function getBreeds(){
        BreedsModel.getBreeds()
                   .then(function (breeds) {
                      vm.breeds = breeds;
                   });
      }

      function returnToPets(reload) {
        PetsModel.resetCurrentPet();
        $state.go('k9.pets', {}, { reload: false });
      }

      function updatePet() {
        vm.pet = angular.copy(vm.editedPet);
        PetsModel.updatePet(vm.editedPet)
                 .then(function (pets) {
                   PetsModel.resetCurrentPet();
                   goBack();
                 });
      }

      vm.deletePet = function deletePet(pet){

        var confirm = $mdDialog.confirm()
                               .title('Are you sure you would like to delete this dog?')
                               .textContent('Deleting the dog will remove all associated records.')
                               .ok('Cancel')
                               .cancel('Delete Pet');

        $mdDialog.show(confirm).then(function(){
          // Default Confirm is to cancel delete
        }, function() {
          // Delete Pet
          PetsModel.deletePet(pet)
                      .then(function () {
                        ClientsModel.removeDogLocally(pet);
                        goBack();
                      });
        });

      };

      function cancelEditing() {
          returnToPets(false);
      }

  }) // end edit pet ctrl

  .config(function ($stateProvider,$httpProvider,$urlRouterProvider) {

    //State Providers
    $stateProvider.state('k9.pets.edit',{
      url: '/pet/:petID/edit',
      views: {
                'main@' : {
                            controller: 'EditPetController as vm',
                            templateUrl: 'app/pets/edit/pet-edit.tmpl.html'
                          }
             }
    });

  });

}()); // end use strict

(function () {
  'use strict';

  angular.module('k9.pets.create', [
    'ui.router',
    'k9.models.pets'
  ])

  .controller('CreatePetController', function(BreedsModel,$state, $stateParams,
                                              PetsModel) {

    // Public
    var vm        = this;
    vm.isSaving   = isSaving;
    vm.cancel     = cancelCreating;
    vm.createPet  = createPet;
    vm.breeds     = [];

    // On Load
    resetForm();
    getBreeds();

    //Private
    var saving = false;

    function isSaving(){
      return saving;
    }

    function getBreeds(){
      BreedsModel.getBreeds()
                 .then(function (breeds) {
                    vm.breeds = breeds;
                 });
    }

    function returnTopets(reload){
      $state.go('k9.pets', {}, { reload: reload });
    }

    function cancelCreating(){
      returnToPets(false);
    }

    function createPet(pet){
      saving = true;
      PetsModel.createPet(pet)
                  .then(function (pets) {
                    PetsModel.addPet(pets.data.dog);
                    saving = false;
                    $state.go('k9.pets', {petID: pets.data.dog.id}, { reload: true });
                  });
    }

    function resetForm(){
      vm.newPet = {
        name: ''
      };
    }

  }) // end create pet ctrl

  .config(function ($stateProvider) {

    //State Providers
    $stateProvider.state('k9.pets.create',{
      url: '/pet/create',
      views: {
                'main@' : {
                            controller: 'CreatePetController as vm',
                            templateUrl: 'app/pets/create/pet-create.tmpl.html'
                          }
             }
    });

  }); // end ui-router

}()); // end use strict

(function () {
  'use strict';

  angular.module('k9.appointment.create', [
    'ui.router'
  ])

  .controller('CreateAppointmentController', function(
      appConfig, $http, MessagesModel, ActivitiesModel,PetsModel, $log, $state,
      $stateParams,CalendarEventsModel, $mdDialog, selectedDate) {

    //Public
    var vm = this;

    vm.isDisabled               =   false;
    vm.pets                     =   loadAll();
    vm.querySearch              =   querySearch;
    vm.newPet                   =   newPet;
    vm.activities               =   [];
    vm.activityChanged          =   activityChanged;
    vm.isSaving                 =   isSaving;

    // Create Array of Booking Times
    vm.bookingTimes             =   CalendarEventsModel.getBookingTimes();
    vm.createAppointment        =   createAppointment;
    vm.deleteAppointment        =   deleteAppointment;
    vm.createAppointmentCancel  =   createAppointmentCancel;
    vm.newAppointment           =   getNewAppointmentDefaults();
    vm.printReceipt             =   printReceipt;
    vm.sendSMSReminder          =   sendSMSReminder;
    vm.isSMSSent                =   isSMSSent;
    vm.smsSendingDisabled       =   smsSendingDisabled;
    vm.getSMSButtonText         =   getSMSButtonText;

    //OnLoad
    getActivities();

    //Private
    var saving = false;
    var SMSSent = false;

    function getSMSButtonText(){
      var label = 'Send SMS Reminder';
      if(SMSSent){
        label = 'Reminder Sent';
      }else if (saving){
        label = 'Sending. Please wait...';
      }
      return label;
    }

    function smsSendingDisabled(){
      return (saving || SMSSent);
    }

    function isSaving(){
      return saving;
    }

    function isSMSSent(){
      return SMSSent;
    }

    function printReceipt(appointment){

      saving = true;

      //Report URL
      // /api/v1/appointments/:appointment_id/receipt
      var reportURL = appConfig.API.baseURL +
                      'appointments/' +
                      appointment.id +
                      '/receipt' +'.pdf';

      // Get file as blob and display
      // Based on http://stackoverflow.com/a/25808659
      // Cannot just open in new tab as need to pass
      // authentication headers and this is not possible by opening new tab
      $http.get(reportURL, {
          responseType: 'arraybuffer'
        })
        .success(function(data) {
          var file = new Blob([data], {
            type: 'application/pdf'
          });
          var fileURL = URL.createObjectURL(file);
          window.open(fileURL);
          saving = false;  //revert state
        });
    }

    function sendSMSReminder(appointment_id){
      saving = true;
      MessagesModel.sendReminderSMS(appointment_id)
                   .then(function(activity) {
                      saving = false;
                      SMSSent = true;
                    });
    }

    function activityChanged(activityID){
      var activityPromise = ActivitiesModel.getActivityById(activityID);

      activityPromise.then(function(activity) {
        vm.newAppointment.charge = parseFloat(activity.default_charge);
      });

    }

    function getActivities(){
      ActivitiesModel.getActivities()
               .then(function (activities) {
                  vm.activities = activities;
               });
    }

    function newPet(pet) {
      alert("Sorry! More information needed for " + pet.name + " first!");
    }

    function querySearch (query) {
      var results = query ? vm.pets.filter( createFilterFor(query) ) : vm.pets;
      return results;
    }

    // Build `pets` list of key/value pairs
    function loadAll() {
      return PetsModel.getPets().then(function(response) {
          vm.pets = response;
          return response;
      });
    }

    // Create filter function for a query string
    function createFilterFor(query) {
      var lowercaseQuery = angular.lowercase(query);
      return function filterFn(pet) {
        return (pet.name.toLowerCase().indexOf(lowercaseQuery) === 0);
      };
    }

    //Private
    function getNewAppointmentDefaults(){
      var dog = (selectedDate.dog===null || !selectedDate.dog.id) ? '' : selectedDate.dog;
      return {
        id: selectedDate.id,
        title: selectedDate.title || '',
        start: selectedDate.start.toDate(),
        dog:  dog,
        charge: selectedDate.charge,
        activity:  selectedDate.activity || {},
        startTime:  {
                      id    : selectedDate.start.format("HH:00:00"),
                      name  : selectedDate.start.format("HH:00")
                   }
      };
    }

    function resetForm(){
      vm.newAppointment = {
        title: ''
      };
    }

    function createAppointmentCancel(){
      $mdDialog.cancel();
    }

    function createAppointment(appointment){

      console.log(createAppointment,'new appointmetn obj');

      // Set Saving state to true
      saving = true;

      if(appointment.id && appointment.id > 0){
        CalendarEventsModel.updateAppointment(appointment)
                           .then(function (response) {
                              $mdDialog.hide(appointment);
                              saving = false;
                           }, function errorCallback(response) {
                                saving = false;
                                alert('Unable to save at this time...');
                            });
      }else{
        CalendarEventsModel.createAppointment(appointment)
                           .then(function (response) {
                              $mdDialog.hide(appointment);
                              saving = false;
                           }, function errorCallback(response) {
                              saving = false;
                              alert('Unable to save at this time...');
                          });
      }

    }

    function deleteAppointment(appointment){
      CalendarEventsModel.deleteAppointment(appointment)
                         .then(function (response) {
                            $mdDialog.hide(appointment);
                         });
    }

  }) // end create appointment controller

  //Routes
  .config(function ($stateProvider) {

    //State Providers
    $stateProvider.state('k9.dashboard.create',{
      url: '/create/appointment',
      views: {
                'main@' : {
                            controller: 'CreateAppointmentController as vm',
                            templateUrl: 'app/dashboard/create/appointment-create.tmpl.html'
                          }
             }
    });

  });

}()); // end use strict

(function() {
  'use strict';

  angular
      .module('k9')
      .service('webDevTec', webDevTec);

  /** @ngInject */
  function webDevTec() {
    var data = [
      {
        'title': 'AngularJS',
        'url': 'https://angularjs.org/',
        'description': 'HTML enhanced for web apps!',
        'logo': 'angular.png'
      },
      {
        'title': 'BrowserSync',
        'url': 'http://browsersync.io/',
        'description': 'Time-saving synchronised browser testing.',
        'logo': 'browsersync.png'
      },
      {
        'title': 'GulpJS',
        'url': 'http://gulpjs.com/',
        'description': 'The streaming build system.',
        'logo': 'gulp.png'
      },
      {
        'title': 'Jasmine',
        'url': 'http://jasmine.github.io/',
        'description': 'Behavior-Driven JavaScript.',
        'logo': 'jasmine.png'
      },
      {
        'title': 'Karma',
        'url': 'http://karma-runner.github.io/',
        'description': 'Spectacular Test Runner for JavaScript.',
        'logo': 'karma.png'
      },
      {
        'title': 'Protractor',
        'url': 'https://github.com/angular/protractor',
        'description': 'End to end test framework for AngularJS applications built on top of WebDriverJS.',
        'logo': 'protractor.png'
      },
      {
        'title': 'Bootstrap',
        'url': 'http://getbootstrap.com/',
        'description': 'Bootstrap is the most popular HTML, CSS, and JS framework for developing responsive, mobile first projects on the web.',
        'logo': 'bootstrap.png'
      },
      {
        'title': 'Angular UI Bootstrap',
        'url': 'http://angular-ui.github.io/bootstrap/',
        'description': 'Bootstrap components written in pure AngularJS by the AngularUI Team.',
        'logo': 'ui-bootstrap.png'
      },
      {
        'title': 'Sass (Ruby)',
        'url': 'http://sass-lang.com/',
        'description': 'Original Syntactically Awesome StyleSheets implemented in Ruby',
        'logo': 'ruby-sass.png'
      }
    ];

    this.getTec = getTec;

    function getTec() {
      return data;
    }
  }

})();

(function() {
  'use strict';

  angular
    .module('k9')
    .directive('k9Navbar', k9Navbar);

  /** @ngInject */
  function k9Navbar() {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/components/navbar/navbar.html',
      scope: {
          creationDate: '='
      },
      controller: NavbarController,
      controllerAs: 'vm',
      bindToController: true
    };

    return directive;

    /** @ngInject */
    function NavbarController(moment) {
      var vm = this;

      // "vm.creation" is avaible by directive option "bindToController: true"
      vm.relativeDate = moment(vm.creationDate).fromNow();
    }
  }

})();

(function () {
   'use strict';

    angular.module("k9.models.profiles",[])

    .service('ProfilesModel', function(appConfig, $http, $q){

      //Public
      var vm                =   this;
      vm.getProfile         =   getProfile;
      vm.updateProfile      =   updateProfile;
      vm.setCurrentProfile  =   setCurrentProfile;

      //Private
      var URLS = { INDEX : appConfig.API.baseURL + 'profiles'},
          profiles;
      var currentProfile = {
        name: '',
        email: '',
        website: '',
        phone: '',
        mobile: '',
        address: '',
        logo: '',
        theme: '',
        tax_number: '',
      };

      function setCurrentProfile(profile){
        currentProfile.name         =   profile.name;
        currentProfile.email        =   profile.email;
        currentProfile.website      =   profile.website;
        currentProfile.phone        =   profile.phone;
        currentProfile.mobile       =   profile.mobile;
        currentProfile.address      =   profile.address;
        currentProfile.logo         =   profile.logo;
        currentProfile.theme        =   profile.theme;
        currentProfile.tax_number   =   profile.tax_number;
      }

      function getProfile(){
        return $http({
                  method  : 'GET',
                  url     : appConfig.API.baseURL + 'profiles/1'
                });
      }

      function updateProfile(profile){
        return $http({
                        method  : 'PATCH', //patch over put for update - https://goo.gl/JRPN2o
                        url     : appConfig.API.baseURL + 'profiles/1',
                        data    : {
                                    profile: {
                                      name        : profile.name,
                                      email       : profile.email,
                                      website     : profile.website,
                                      phone       : profile.phone,
                                      mobile      : profile.mobile,
                                      address     : profile.address,
                                      logo        : profile.logo,
                                      theme       : profile.theme,
                                      tax_number  : profile.tax_number
                                    }
                                  }

                      }).then(function (response) {
                        var profile = response.data.profile;
                        setCurrentProfile(profile);
                      });
      }

    }); //end service profile model

}()); //end use strict

(function () {
   'use strict';

    angular.module("k9.models.photos",[])

    .service('PhotosModel', function(appConfig, $http, $q){

      //Public
      var vm    =   this;
      vm.find   =   getByID;
      vm.save   =   save;
      vm.delete =   deletePhoto;

      //Private
      var URLS = { INDEX : appConfig.API.baseURL + 'photos'},
          photos;

      // Returns one set of photo details for a given ID
      function getByID(photoID){
        return $http({
          method  : 'GET',
          url     : appConfig.API.baseURL +'photo/' + photoID
        });
      }

      // Saves a photo - Includes adding new photos or updating existing ones
      function save(photo){

        var saveMethod, saveURL;
        if(photo.id && photo.id > 0){
          saveMethod =  'PUT';
          saveURL = appConfig.API.baseURL +'photos/' + photo.id;
        }else{
          saveMethod = 'POST';
          saveURL = appConfig.API.baseURL +'photos';
        }

        return $http({
          method  : saveMethod,
          url     : saveURL,
          data    : {
                      photo: {
                        title  : photo.title
                      }
                    }
        });
      }

      // Function deletes a photo based on ID
      function deletePhoto(photo){
        return $http({
          method  : 'DELETE',
          url     :  appConfig.API.baseURL + 'photos/' + photo.id
        });
      }

    }); //end service photo model

}()); //end use strict

(function () {
   'use strict';

    angular.module("k9.models.pets",[])

    .service('PetsModel', function(appConfig, $http, $q){

      //Public
      var vm                =   this;
      vm.getCurrentPet      =   getCurrentPet;
      vm.setCurrentPet      =   setCurrentPet;
      vm.resetCurrentPet    =   resetCurrentPet;
      vm.getPets            =   getPets;
      vm.addPet             =   addPet;
      vm.createPet          =   createPet;
      vm.createPetWithOwner =   createPetWithOwner;
      vm.getPetById         =   getPetById;
      vm.updatePet          =   updatePet;
      vm.deletePet          =   deletePet;

      //Private
      var URLS = { INDEX : appConfig.API.baseURL + 'dogs'},
          pets;

      var currentPet = {
        name: '',
        note:'',
        breed: {
          id:'',
          name:''
        },
        photos:[]
      };

      function getCurrentPet(pet){
        return currentPet;
      }

      function setCurrentPet(pet){
        currentPet.id = pet.id;
        currentPet.name = pet.name;
        currentPet.note = pet.note;
        currentPet.breed = {
          id: (pet.breed !== null) ? pet.breed.id : 0,
          name: (pet.breed !== null) ? pet.breed.name : ''
        };
        currentPet.photos = pet.photos;
      }

      function resetCurrentPet(){
        currentPet.name   = '';
        currentPet.note   = '';
        currentPet.photos = [];
        currentPet.breed  = {
                              id:'',
                              name:''
                            };
      }

      function getPets(){
        return (pets) ? $q.when(pets) : $http.get(URLS.INDEX).then(cachePets);
      }

      function addPet(pet){
        if(pets){
            pets.unshift(pet);
        }
      }

      function createPet(pet){

        //Check for breed
        if(pet.breed){
            pet.breed_id = pet.breed.id; //Makes API call easier
        }

        return $http({
          method  : 'POST',
          url     : appConfig.API.baseURL +'dogs',
          data    : {
                      dog: pet
                    }
        });

      }

      function createPetWithOwner(pet,ownerID){
        // Function creates a new dog that is linked
        // to a particular owner

        //Check for breed
        if(pet.breed){
            pet.breed_id = pet.breed.id; //Makes API call easier
        }

        return $http({
          method  : 'POST',
          url     : appConfig.API.baseURL + 'clients/' + ownerID + '/dogs',
          data    : {
                      dog: pet
                    }
        });

      }

      function getPetById(petID){
        var deferred = $q.defer();

        if (pets) {
            deferred.resolve(findPet(petID));
        } else {
            vm.getPets().then(function () {
                deferred.resolve(findPet(petID));
            });
        }
        return deferred.promise;
      }

      function updatePet(pet){

        //Check for breed
        if(pet.breed){
            pet.breed_id = pet.breed.id; //Makes API call easier
        }

        return $http({
                        method  : 'PATCH', //patch over put for update - https://goo.gl/JRPN2o
                        url     : appConfig.API.baseURL + 'dogs/' + pet.id,
                        data    : {
                                    dog: pet
                                  }

                      }).then(function (response) {
                        // Update pet in local array
                        var pet = response.data.dog;

                        var matchedPet = _.find(pets, function (c) {
                            return c.id == parseInt(pet.id, 10);
                        });

                        matchedPet.name = pet.name;
                        matchedPet.note = pet.note;
                        matchedPet.photos = pet.photos;

                        // Breed
                        if(pet.breed !== null){
                          matchedPet.breed = {
                            id: pet.breed.id,
                            name: pet.breed.name
                          };
                        }else{
                          matchedPet.breed = null;
                        }

                      });
      }

      function deletePet(pet){

        return $http({
          method  : 'DELETE',
          url     :  appConfig.API.baseURL + 'dogs/' + pet.id
        })
        .then(function deletePetsuccessCallback(response) {
          //Remove from in memory array
          _.remove(pets, function(c) {
            return c.id == pet.id;
          });
        });

      }

      function extract(result){
        return result.data.dogs;
      }

      function cachePets(result){
        pets = extract(result);
        return pets;
      }

      function findPet(petID) {
        var result = _.find(pets, function (c) {
            return c.id == parseInt(petID, 10);
        });
        return result;
      }

    }); //end service pet model

}()); //end use strict

(function () {
   'use strict';

   angular.module("k9.models.nav",[
     'ui.router'
   ])

  .service("NavModel", function NavModelService($timeout, $mdSidenav, $log, $compile, $state){

    //Public
    var vm = this;
    vm.menuItem             =   getMenuItem;
    vm.menuIsSelected       =   menuIsSelected;
    vm.getMenuItems         =   getMenuItems;
    vm.getCurrentItem       =   getCurrentItem;
    vm.setCurrentItem       =   setCurrentItem;
    vm.buildDelayedToggler  =   buildDelayedToggler;
    vm.closeSideMenu        =   closeSideMenu;

    //Private

    function closeSideMenu(){
      $mdSidenav('left').close();
    }

    function debounce(func, wait, context) {
      return function debounced() {
        $mdSidenav('left').toggle();
      };
    }

    function buildDelayedToggler(navID) {
      return debounce(function() {
        $mdSidenav(navID)
          .toggle()
          .then(function () {
            $log.debug("toggle " + navID + " is done");
          });
      }, 200);
    }

    var currentItem;
    var menuItem = function menuItem(title,sref,icon){
      // must be a nicer way to do this, feels wrong but not found it yet
      // only purpose is to make creating new object shorter later
      return {
        title : title,
        sref : sref,
        icon : icon
      };
    };

    //Default values
    var menuItems = [
      menuItem('Dashboard','k9.dashboard','dashboard'),
      menuItem('Clients','k9.clients','face'),
      menuItem('Pets','k9.pets','paw'),
      menuItem('Reports','k9.report','my_library_books'), //assessment
      menuItem('Settings','k9.settings.breeds','settings'),
      menuItem('Profile','k9.profile','assignment_ind')
      // menuItem('Social Media','k9.social','facebook-box')
    ];

    function getMenuItem(title,sref){
      return menuItem;
    }

    function menuIsSelected(menuItem){
      if(!currentItem) return false; // in case there is no current item
      return (menuItem.title === currentItem.title) ? true : false;
    }

    function getMenuItems(){
      return menuItems;
    }

    function getCurrentItem(){
      return currentItem;
    }

    function setCurrentItem(menuItem){
      currentItem = menuItem;
    }

  }); //end navigation model

}()); //end use strict

(function () {
   'use strict';

    angular.module("k9.models.messages",[])

    .service('MessagesModel', function(appConfig, $http, $q){

      //Public
      var vm              =   this;
      vm.sendReminderSMS  =   sendReminderSMS;

      //Private
      var URLS = { INDEX : appConfig.API.baseURL + 'messages'};

      // Saves a photo - Includes adding new photos or updating existing ones
      function sendReminderSMS(appointment_id){

        var saveMethod, saveURL;

        return $http({
          method  : 'POST',
          url     : URLS.INDEX + '/reminder',
          data    : {
                      message: {
                        appointment_id : appointment_id
                      }
                    }
        });
      }

    }); //end messages model

}()); //end use strict

(function () {
   'use strict';

    angular.module("k9.models.clients",[])

    .service('ClientsModel', function(Upload,appConfig, $http, $q){

      //Public
      var vm = this, clients;
      var URLS = {
                    INDEX : appConfig.API.baseURL + 'clients'
                  };

      vm.getCurrentClient       =   getCurrentClient;
      vm.setCurrentClient       =   setCurrentClient;
      vm.resetCurrentClient     =   resetCurrentClient;
      vm.getClients             =   getClients;
      vm.addClient              =   addClient;
      vm.createClient           =   createClient;
      vm.getClientById          =   getClientById;
      vm.updateClient           =   updateClient;
      vm.deleteClient           =   deleteClient;
      vm.addDogLocally          =   addDogLocally;
      vm.removeDogLocally       =   removeDogLocally;
      vm.updateImage            =   updateImage;
      vm.setCurrentClientImages =   setCurrentClientImages;
      vm.getDefaultImages       =   getDefaultImages;
      vm.refreshClientPets      =   refreshClientPets;

      //Private
      var imageSrcRoot = 'https://res.cloudinary.com/groomk9/image/upload/';
      var imageSrc = {
        menu_default: 'c_thumb,h_60,r_max,w_60/v1462814809/paw_missing_bigxou.png',
        thumb_processing: '/app/assets/img/placeholder_client_processing.png',
        thumb_default: '/app/assets/img/placeholder_client.png'
      };

      var currentClient = {
        id:0,
        first_name: '',
        last_name: '',
        initials:'',
        phone: '',
        email: '',
        address:'',
        dogs: [],
        picture_thumb_cropped: ''
      };

      function getDefaultImages(){
        return imageSrc;
      }

      function refreshClientPets(clientID){
        $http({
          method  : 'GET',
          url     : URLS.INDEX + '/' + clientID
        })
        .then(function (response) {
          var client = response.data.client;
          currentClient.dogs = client.dogs;
        });
      }

      function setCurrentClientImages(images){

        // Image to show while main image is uploaded
        var processingCropped = imageSrc.thumb_processing;
        var croppedImage = (images.cropped  && images.cropped.length > 0) ?
                                            images.cropped : processingCropped;

        // Update Client in List
        var matchedClient = _.find(clients, function (c) {
            return c.id == parseInt(currentClient.id, 10);
        });

        // Update Object In List
        // (this should be reviewed, 2 diff ref to same model, 1 on edit, 1 on list)
        currentClient.picture_thumb_cropped = croppedImage;
        currentClient.thumbnail_menu = images.menu;

        matchedClient.picture_thumb_cropped = croppedImage;
        matchedClient.thumbnail_menu = images.menu;

      }

      function updateImage(file){
        // only ever need PUT method as will only allow images to be
        // attached to existing Clients

        return Upload.upload({
            url: URLS.INDEX + '/' + currentClient.id,
            method: 'PUT',
            data: {'client[picture]': file}
            // Other data can be passed if required... data: {'client[picture]':
            // file, 'client[first_name]': 'xxxxxxxxy'}
        });

      }

      function addDogLocally(dog){
        currentClient.dogs.push(dog);
      }

      function removeDogLocally(pet){
        _.remove(currentClient.dogs, function(c) {
          return c.id == pet.id;
        });
      }

      function getCurrentClient(client){
        return currentClient;
      }

      function setCurrentClient(client){
        currentClient.id          = client.id;
        currentClient.first_name  = client.first_name;
        currentClient.last_name   = client.last_name;
        currentClient.initials    = client.initials;
        currentClient.phone       = client.phone;
        currentClient.email       = client.email;
        currentClient.dogs        = client.dogs;
        currentClient.address     = client.address;

        if(client.picture_thumb_cropped.length > 0 ||
          client.picture_thumb_cropped == 'undefined'){
          // Show image stored on client record
          currentClient.picture_thumb_cropped = client.picture_thumb_cropped;
        }else{
          // No image recorded against Client show placeholder
          currentClient.picture_thumb_cropped = imageSrc.thumb_default;
        }

      }

      function resetCurrentClient(){
        currentClient.id = 0;
        currentClient.first_name = '';
        currentClient.last_name = '';
        currentClient.initial = '';
        currentClient.phone = '';
        currentClient.email = '';
        currentClient.addres = '';
        currentClient.dogs = [];
        currentClient.picture_thumb_cropped = '';
      }

      function getClients(){
        return (clients) ? $q.when(clients) : $http.get(URLS.INDEX).then(cacheClients);
      }

      function addClient(client){
        if(clients.length > 0){
          clients.unshift(client);
        }
      }

      function createClient(client){

        return $http({
          method  : 'POST',
          url     : appConfig.API.baseURL +'clients',
          data    : {
                      client: {
                        first_name  : client.firstname,
                        last_name   : client.lastname,
                        initials    : client.initials,
                        phone       : client.phone,
                        email       : client.email,
                        address     : client.address
                      }
                    }
        });

      }

      function getClientById(clientID){
        var deferred = $q.defer();

        if (clients) {
            deferred.resolve(findClient(clientID));
        } else {
            vm.getClients().then(function () {
                deferred.resolve(findClient(clientID));
            });
        }
        return deferred.promise;
      }

      function updateClient(client){
        return $http({
                        method  : 'PATCH', //patch over put for update - https://goo.gl/JRPN2o
                        url     : appConfig.API.baseURL + 'clients/' + client.id,
                        data    : {
                                    client: {
                                      first_name  : client.first_name,
                                      last_name   : client.last_name,
                                      initials    : client.initials,
                                      phone       : client.phone,
                                      email       : client.email,
                                      address     : client.address
                                    }
                                  }

                      }).then(function (response) {
                        var client = response.data.client;
                        var matchedClient = _.find(clients, function (c) {
                            return c.id == parseInt(client.id, 10);
                        });
                        matchedClient.first_name = client.first_name;
                        matchedClient.last_name  = client.last_name;
                        matchedClient.initials   = client.initials;
                        matchedClient.phone      = client.phone;
                        matchedClient.email      = client.email;
                        matchedClient.address    = client.address;
                      });
      }

      function deleteClient(client){

        return $http({
          method  : 'DELETE',
          url     :  appConfig.API.baseURL + 'clients/' + client.id
        })
        .then(function deleteClientSuccessCallback(response) {
          //Remove from in memory array
          _.remove(clients, function(c) {
            return c.id == client.id;
          });
        });

      }

      function extract(result){
        return result.data;
      }

      function cacheClients(result){
        clients = extract(result);
        return clients;
      }

      function findClient(clientID) {

        var result = _.find(clients, function (c) {
            return c.id == parseInt(clientID, 10);
        });
        return result;
      }

    }); //end service client model

}()); //end use strict

(function () {
   'use strict';

    angular.module("k9.models.calendar_events",[])

    .service('CalendarEventsModel', function(appConfig, $http, $q){

      //Public
      var vm = this, calendarEvents;
      var URLS = {
                    APPOINTMENTS : appConfig.API.baseURL + 'appointments'
                  };

      vm.newCalendarEvent           =   newCalendarEvent;
      vm.getBookingTimes            =   getBookingTimes;
      vm.createAppointment          =   createAppointment;
      vm.updateAppointment          =   updateAppointment;
      vm.deleteAppointment          =   deleteAppointment;
      vm.getCalendarEvents          =   getCalendarEvents;
      vm.getCalendarEventsForClient =   getCalendarEventsForClient;

      //Private
      function newCalendarEvent(){
        return {
          id:           '',
          title:        '',
          description:  '',
          note:         '',
          start:        '',
          end:          '',
          dog:          {},
          activity:     {},
          charge:       0
        };
      }

      function createAppointment(newAppointment){
        return _updateAppointment(newAppointment,'create');
      }

      function getBookingTimes(){
        var times = [];
        var day1 = moment("2015-01-01"); // pick any day range
        var day2 = moment("2015-01-02");

        // Start at 00:00 and loop over every 30mins to build up times
        while(day1.diff(day2) < 0){
            times.push({
             id: day1.format("HH:mm:ss"),
             name: day1.format("HH:mm")
            });
            day1.add(30, 'minutes');
        }
        return times;
      }

      function updateAppointment(newAppointment){
        return _updateAppointment(newAppointment,'update');
      }

      function deleteAppointment(appointment){
        return $http({
          method  : 'DELETE',
          url     : URLS.APPOINTMENTS + '/' + appointment.id
        }).then(function (response) {
          //Remove from in memory array
          _.remove(calendarEvents, function(calEvents) {
            return calEvents.id == appointment.id;
          });
        });
      }

      function getCalendarEvents(){
        return (calendarEvents) ? $q.when(calendarEvents) : $http.get(URLS.APPOINTMENTS).then(cacheCalendarEvents);
      }

      function getCalendarEventsForClient(client_id){
        var clientAppointmetnsURL = URLS.APPOINTMENTS + '?client_id=' + client_id;
        return $http.get(clientAppointmetnsURL);
      }

      function extract(result){
        // end is a reserved word in ruby and mssql etc
        // so start and end on API side are refered to as start_at
        // and end_at

        var appointments = result.data.appointments;

        for (var i = 0; i < appointments.length; i++) {

          // Copy properties into new keys
          appointments[i].start = appointments[i].start_at;
          appointments[i].end = appointments[i].end_at;

          // Remove old keys
          delete appointments[i].start_at;
          delete appointments[i].end_at;
        }

        return appointments;
      }

      function cacheCalendarEvents(result){
        calendarEvents = extract(result);
        return calendarEvents;
      }

      function concatDateAndTime(appointmentDate,appointmentTime){

        var parsedTime  =   appointmentTime.split(':');
        var hours       =   parsedTime[0];
        var minutes     =   parsedTime[1];

        return moment(appointmentDate)
               .startOf('day') // reset time before adding values from form
               .add(hours, 'hours')
               .add(minutes, 'minutes');
      }

      function _updateAppointment(newAppointment,updateType){

        var appointment = angular.copy(newAppointment);

        //Concat Start Date and Time and return as moment object
        var start = concatDateAndTime(
                                        appointment.start,
                                        appointment.startTime.name
                                      );

        //New Record Vs Updating Record
        var dogID = (appointment.dog !== null &&
                          appointment.dog.hasOwnProperty('id')) ? appointment.dog.id : '';

        console.log(appointment,'in the model before save...');
                          
        var updateParams = {
          methodx: 'POST',
          url: URLS.APPOINTMENTS,
          appointment: {
            title         : appointment.title,
            start_at      : start.format('YYYY-MM-DD HH:mm'),
            end_at        : start.format('YYYY-MM-DD HH:mm'), //calendarAppointment.end,
            dog_id        : dogID,
            activity_id   : appointment.activity.id,
            charge        : parseFloat(appointment.charge)
          }
        };

        if(updateType==='update'){
          // Update existing record
          updateParams.methodx = 'PUT';
          updateParams.url = URLS.APPOINTMENTS + '/' + appointment.id;
        }

        //Call backend API and update/create
        return $http({
          method  : updateParams.methodx,
          url     : updateParams.url,
          data    : {
                      appointment: updateParams.appointment,
                      sendEmailConfirmation : appointment.sendEmailConfirmation
                    }
        }).then(function (response) {
          var newAppointment = response.data.appointment;

          // If user loads add page directly without
          // going through the index then calendarEvents was never retrieved
          if(calendarEvents){

            if(updateType==='update'){
              // Find existing record and update details
              var matchedCalendarEvent = _.find(calendarEvents, function (c) {
                  return c.id == parseInt(newAppointment.id, 10);
              });
              matchedCalendarEvent.title        =   newAppointment.title;
              matchedCalendarEvent.description  =   newAppointment.description;
              matchedCalendarEvent.note         =   newAppointment.note;
              matchedCalendarEvent.start        =   newAppointment.start_at;
              matchedCalendarEvent.end          =   newAppointment.end_at;
              matchedCalendarEvent.dog          =   newAppointment.dog;
              matchedCalendarEvent.charge       =   parseFloat(newAppointment.charge);
            }else{
              // New Appointxment add to events list
              // Copy properties into new keys
              newAppointment.start = newAppointment.start_at;
              newAppointment.end = newAppointment.end_at;

              // Remove old keys
              delete newAppointment.start_at;
              delete newAppointment.end_at;

              calendarEvents.push(newAppointment);
            }

          }

        });

      }

    }); //end service calendar events model

}()); //end use strict

(function () {
   'use strict';

    angular.module("k9.models.breeds",[])

    .service('BreedsModel', function(appConfig, $http, $q){

      //Public
      var vm                =   this;
      vm.getCurrentBreed      =   getCurrentBreed;
      vm.setCurrentBreed      =   setCurrentBreed;
      vm.resetCurrentBreed    =   resetCurrentBreed;
      vm.getBreeds            =   getBreeds;
      vm.addBreed             =   addBreed;
      vm.createBreed          =   createBreed;
      vm.createBreedWithOwner =   createBreedWithOwner;
      vm.getBreedById         =   getBreedById;
      vm.updateBreed          =   updateBreed;
      vm.deleteBreed          =   deleteBreed;

      //Private
      var URLS = { INDEX : appConfig.API.baseURL + 'breeds'},
          breeds;

      var currentBreed = {
        name: ''
      };

      function getCurrentBreed(breed){
        return currentBreed;
      }

      function setCurrentBreed(breed){
        currentBreed.id = breed.id;
        currentBreed.name = breed.name;
      }

      function resetCurrentBreed(){
        currentBreed.name = '';
      }

      function getBreeds(){
        return (breeds) ? $q.when(breeds) : $http.get(URLS.INDEX).then(cacheBreeds);
      }

      function addBreed(breed){
        if(breeds){
            breeds.unshift(breed);
        }
      }

      function createBreed(breed){

        return $http({
          method  : 'POST',
          url     : appConfig.API.baseURL +'breeds',
          data    : {
                      breed: {
                        name  : breed.name
                      }
                    }
        });

      }

      function createBreedWithOwner(breed,ownerID){
        // Function creates a new breed that is linked
        // to a particular owner

        return $http({
          method  : 'POST',
          url     : appConfig.API.baseURL + 'clients/' + ownerID + '/breeds',
          data    : {
                      breed: {
                        name  : breed.name
                      }
                    }
        });

      }

      function getBreedById(breedID){
        var deferred = $q.defer();

        if (breeds) {
            deferred.resolve(findBreed(breedID));
        } else {
            vm.getBreeds().then(function () {
                deferred.resolve(findBreed(breedID));
            });
        }
        return deferred.promise;
      }

      function updateBreed(breed){
        return $http({
                        method  : 'PATCH', //patch over put for update - https://goo.gl/JRPN2o
                        url     : appConfig.API.baseURL + 'breeds/' + breed.id,
                        data    : {
                                    breed: {
                                      name  : breed.name
                                    }
                                  }

                      }).then(function (response) {
                        var breed = response.data.breed;
                        var matchedBreed = _.find(breeds, function (c) {
                            return c.id == parseInt(breed.id, 10);
                        });
                        matchedBreed.name = breed.name;
                      });
      }

      function deleteBreed(breed){

        return $http({
          method  : 'DELETE',
          url     :  appConfig.API.baseURL + 'breeds/' + breed.id
        })
        .then(function deleteBreedsuccessCallback(response) {
          //Remove from in memory array
          _.remove(breeds, function(c) {
            return c.id == breed.id;
          });
        });

      }

      function extract(result){
        return result.data.breeds;
      }

      function cacheBreeds(result){
        breeds = extract(result);
        return breeds;
      }

      function findBreed(breedID) {
        var result = _.find(breeds, function (c) {
            return c.id == parseInt(breedID, 10);
        });
        return result;
      }

    }); //end service breed model

}()); //end use strict

(function () {
   'use strict';

    angular.module("k9.models.activities",[])

    .service('ActivitiesModel', function(appConfig, $http, $q){

      //Public
      var vm                     =   this;
      vm.getCurrentActivity      =   getCurrentActivity;
      vm.setCurrentActivity      =   setCurrentActivity;
      vm.resetCurrentActivity    =   resetCurrentActivity;
      vm.getActivities           =   getActivities;
      vm.addActivity             =   addActivity;
      vm.createActivity          =   createActivity;
      vm.getActivityById         =   getActivityById;
      vm.updateActivity          =   updateActivity;
      vm.deleteActivity          =   deleteActivity;

      //Private
      var URLS = { INDEX : appConfig.API.baseURL + 'activities'},
          activities;

      var currentActivity = {
        description: ''
      };

      function getCurrentActivity(activity){
        return currentActivity;
      }

      function setCurrentActivity(activity){
        currentActivity.id = activity.id;
        currentActivity.description = activity.description;
        currentActivity.default_charge = parseFloat(activity.default_charge);
        currentActivity.active = activity.active;
      }

      function resetCurrentActivity(){
        currentActivity.description = '';
      }

      function getActivities(){
        return (activities) ? $q.when(activities) : $http.get(URLS.INDEX).then(cacheActivities);
      }

      function addActivity(activity){
        if(activities){
            activities.unshift(activity);
        }
      }

      function createActivity(activity){

        return $http({
          method  : 'POST',
          url     : appConfig.API.baseURL +'activities',
          data    : {
                      activity: {
                        description     : activity.description,
                        default_charge  : parseFloat(activity.default_charge),
                        active          : activity.active
                      }
                    }
        });

      }

      function getActivityById(activityID){
        var deferred = $q.defer();

        if (activities) {
            deferred.resolve(findActivity(activityID));
        } else {
            vm.getActivities().then(function () {
                deferred.resolve(findActivity(activityID));
            });
        }
        return deferred.promise;
      }

      function updateActivity(activity){
        return $http({
                        method  : 'PATCH', //patch over put for update - https://goo.gl/JRPN2o
                        url     : appConfig.API.baseURL + 'activities/' + activity.id,
                        data    : {
                                    activity: {
                                      description     : activity.description,
                                      default_charge  : parseFloat(activity.default_charge),
                                      active          : activity.active
                                    }
                                  }

                      }).then(function (response) {
                        var activity = response.data.activity;
                        var matchedActivity = _.find(activities, function (c) {
                            return c.id == parseInt(activity.id, 10);
                        });
                        matchedActivity.description     =   activity.description;
                        matchedActivity.default_charge  =   parseFloat(activity.default_charge);
                        matchedActivity.active          =   activity.active;
                      });
      }

      function deleteActivity(activity){

        return $http({
          method  : 'DELETE',
          url     :  appConfig.API.baseURL + 'activities/' + activity.id
        })
        .then(function deleteActivitiesuccessCallback(response) {
          //Remove from in memory array
          _.remove(activities, function(c) {
            return c.id == activity.id;
          });
        });

      }

      function extract(result){
        return result.data.activities;
      }

      function cacheActivities(result){
        activities = extract(result);
        return activities;
      }

      function findActivity(activityID) {
        var result = _.find(activities, function (c) {
            return c.id == parseInt(activityID, 10);
        });
        return result;
      }

    }); //end service activity model

}()); //end use strict

// Based on: http://stackoverflow.com/a/32574746
(function () {
    'use strict';

    angular.module('k9')
           .directive('routeCssClassnames', routeCssClassnames);

    function routeCssClassnames($rootScope) {
        return {
            restrict: 'A',
            scope: {},
            link: function (scope, elem, attr, ctrl) {

                $rootScope.$on('$stateChangeSuccess', function (event, toState, toParams, fromState, fromParams) {
                    var fromClassnames = angular.isDefined(fromState.data) && angular.isDefined(fromState.data.cssClassnames) ? fromState.data.cssClassnames : null;
                    var toClassnames = angular.isDefined(toState.data) && angular.isDefined(toState.data.cssClassnames) ? toState.data.cssClassnames : null;
                    // don't do anything if they are the same
                    if (fromClassnames != toClassnames) {
                        if (fromClassnames) {
                            elem.removeClass(fromClassnames);
                        }

                        if (toClassnames) {
                            elem.addClass(toClassnames);
                        }
                    }
                });
            }
        };
    }
}());

(function () {
  'use strict';

  angular.module('k9.clients.view', [
    'ui.router',
    'k9.models.clients'
  ])

  .controller('ViewClientController', function (CalendarEventsModel,$state, $stateParams, ClientsModel,$mdDialog) {

      //Public
      var vm            =   this;
      vm.client         =   ClientsModel.getCurrentClient();
      vm.editClient     =   editClient;
      vm.createPet      =   createPet;
      vm.editPet        =   editPet;
      vm.appointments   =   [];
      vm.addAppointment =   addAppointment;

      // Onload
      getClientById();
      getAppointments($stateParams.clientID);

      //Private
      function getAppointments(clientID){
        CalendarEventsModel.getCalendarEventsForClient(clientID)
                           .then(function (response) {
                              vm.appointments = response.data.appointments;
                           });
      }

      function addAppointment(){
        var calendarEvent = angular.copy(CalendarEventsModel.newCalendarEvent());

        // If using month view there is no valid month,
        // update to use next hour
        calendarEvent.start = moment().startOf('day')
                                      .hours(moment().hours() + 1);

        $mdDialog.show({
          controller    : 'CreateAppointmentController as vm',
          templateUrl   : 'app/dashboard/create/appointment-create.tmpl.html',
          parent        :  angular.element(document.body),
          // targetEvent   : jsEvent,
          clickOutsideToClose:true,
          locals: { selectedDate: calendarEvent }
        })
        .then(function(appointment) {
          getAppointments($stateParams.clientID);
        }, function() {
          // Cancelled
        });
      }

      // Go to edit
      function editPet(pet){
        $state.go('k9.pets.edit', { petID:pet.id} );
      }

      function createPet(jsEvent){

          $mdDialog.show({
            controller    : 'CreatePetPopController as vm',
            templateUrl   : 'app/pets/create/pop/pet-create-pop.tmpl.html',
            parent        :  angular.element(document.body),
            targetEvent   : jsEvent,
            clickOutsideToClose:true,
            locals: {client: vm.client}
          });

      }

      function getClientById() {
        ClientsModel.getClientById($stateParams.clientID)
                    .then(function (client) {
                        if (client) {
                            ClientsModel.setCurrentClient(client);
                            ClientsModel.refreshClientPets(client.id);
                        } else {
                            returnToClients(true);
                        }
                    });
      }

      // Go to edit
      function editClient(client){
        $state.go('k9.clients.edit', { clientID:client.id} );
      }

      function returnToClients(reload) {
        ClientsModel.resetCurrentClient();
        $state.go('k9.clients', {}, { reload: false });
      }

  }) // end view client controller

  //Routes
  .config(function ($stateProvider,$httpProvider,$urlRouterProvider) {

    //State Providers
    $stateProvider.state('k9.clients.view',{
      url: '/client/:clientID/view',
      views: {
                'main@' : {
                            controller: 'ViewClientController as vm',
                            templateUrl: 'app/clients/view/client-view.tmpl.html'
                          }
             }
    });

  });

}()); // end use strict

(function () {
  'use strict';

  angular.module('k9.clients.edit', [
    'ui.router',
    'k9.models.clients'
  ])

  .controller('EditClientController', function (Upload,$scope,$state,$stateParams, ClientsModel,$mdDialog) {

      //Public
      var vm                  =   this;
      vm.editedClient         =   ClientsModel.getCurrentClient();
      vm.deleteClient         =   deleteClient;
      vm.cancelEditing        =   cancelEditing;
      vm.updateClient         =   updateClient;
      vm.viewClient           =   viewClient;
      vm.editedClient.picture =   {};
      vm.isSaving             =   isSaving;

      // On Load
      getClientById();

      //Private
      var saving = false;

      function isSaving(){
        return saving;
      }

      function viewClient(client){
        $state.go('k9.clients.view', { clientID:client.id} );
      }

      function getClientById() {
        ClientsModel.getClientById($stateParams.clientID)
                    .then(function (client) {
                        if (client) {
                            ClientsModel.setCurrentClient(client);
                        } else {
                            returnToClients(true);
                        }
                    });
      }

      function returnToClients(reload) {
        ClientsModel.resetCurrentClient();
        vm.viewClient(vm.editedClient);
        // $state.go('k9.clients', {}, { reload: false });
      }

      function updateClient() {
        saving = true;
        var client = angular.copy(vm.editedClient);
        ClientsModel.updateClient(vm.editedClient)
                    .then(function (clients) {

            // Main Details have been saved. Return user to client edit
            saving = false;
            vm.viewClient(vm.editedClient);

            //After updating main client details (excluding picture) return to main details
            if(vm.editedClient.picture.name){

              ClientsModel.setCurrentClientImages('','');
              // Now upload image and refresh thumbnail when done
              // Done like this as image upload is slower and using 3rd party
              // no point making the end user wait for it to be complete

              ClientsModel.updateImage(vm.editedClient.picture)
                  .then(function (resp) {
                      // Set newly updated image to model
                      var croppedImageSrc = resp.data.client.picture_thumb_cropped;
                      var menuImageSrc    = resp.data.client.thumbnail_menu;
                      ClientsModel.setCurrentClientImages({
                        cropped : croppedImageSrc,
                        menu    : menuImageSrc
                      });
                  }, function (resp) {
                      console.log('Error uploading client image. Status: ' + resp.status);
                  }, function (evt) {
                      var progressPercentage = parseInt(100.0 * evt.loaded / evt.total);
                      console.log('Upload Progress: ' + progressPercentage + '% ');
              });
            }

          }); //end client model update
      }

      function deleteClient(client){

        var confirm = $mdDialog.confirm()
                               .title('Are you sure you would like to delete this client?')
                               .textContent('Deleting the client will remove all associated records.')
                               .ok('Cancel')
                               .cancel('Delete Client');

        $mdDialog.show(confirm).then(function(){
          // Default Confirm is to cancel delete
        }, function() {
          // Delete Client
          ClientsModel.deleteClient(client)
                      .then(function () {
                        returnToClients(true);
                      });
        });

      }

      function cancelEditing() {
          returnToClients(false);
      }

  }) // end edit client controller

  //Routes
  .config(function ($stateProvider,$httpProvider,$urlRouterProvider) {

    //State Providers
    $stateProvider.state('k9.clients.edit',{
      url: '/client/:clientID/edit',
      views: {
                'main@' : {
                            controller: 'EditClientController as vm',
                            templateUrl: 'app/clients/edit/client-edit.tmpl.html'
                          }
             }
    });

  });

}()); // end use strict

(function () {
  'use strict';

  angular.module('k9.clients.create', [
    'ui.router',
    'k9.models.clients'
  ])

  .controller('CreateClientController', function($state, $stateParams, ClientsModel) {

    //Public
    var vm            = this;
    vm.cancel         = cancelCreating;
    vm.createClient   = createClient;
    vm.isSaving       = isSaving;

    // On Load
    resetForm();

    //Private
    var saving = false;

    function isSaving(){
      return saving;
    }

    function returnToClients(reload){
      $state.go('k9.clients', {}, { reload: reload });
    }

    function cancelCreating(){
      returnToClients(false);
    }

    function createClient(client){
      saving = true;
      ClientsModel.createClient(client)
                  .then(function (clients) {
                      ClientsModel.addClient(clients.data.client);
                      saving = false;
                      $state.go(
                                  'k9.clients.view',
                                  {clientID: clients.data.client.id},
                                  { reload: true }
                                );
                  });
    }

    function resetForm(){
      ClientsModel.resetCurrentClient();
      vm.newClient = angular.copy(ClientsModel.getCurrentClient());
    }

  }) // end create client controller

  //Routes
  .config(function ($stateProvider) {

    //State Providers
    $stateProvider.state('k9.clients.create',{
      url: '/client/create',
      views: {
                'main@' : {
                            controller: 'CreateClientController as vm',
                            templateUrl: 'app/clients/create/client-create.tmpl.html'
                          }
             }
    });

  });

}()); // end use strict

(function () {
  'use strict';

  angular.module('k9.breeds.edit', [
    'ui.router',
    'k9.models.breeds'
  ])

  .config(function ($stateProvider,$httpProvider,$urlRouterProvider) {

    //State Providers
    $stateProvider.state('k9.breeds.edit',{
      url: '/breed/:breedID/edit',
      views: {
                'main@' : {
                            controller: 'EditBreedController as vm',
                            templateUrl: 'app/breeds/edit/breed-edit.tmpl.html'
                          }
             }
    });

  })

  .controller('EditBreedController', function ($state, $stateParams, ClientsModel, BreedsModel,$mdDialog) {

      var vm = this;

      //Menu Icon Animation
      vm.clickIcon = 'menu';
      setTimeout(function(){
         vm.clickIcon = 'keyboard_backspace';
      }, 1);

      vm.editedBreed = BreedsModel.getCurrentBreed();

      function returnToBreeds(reload) {
        BreedsModel.resetCurrentBreed();
        $state.go('k9.settings.breeds', {}, { reload: false });
      }

      function updateBreed() {
        vm.breed = angular.copy(vm.editedBreed);
        BreedsModel.updateBreed(vm.editedBreed)
                    .then(function (breeds) {
                      returnToBreeds(true);
                    });
      }

      vm.deleteBreed = function deleteBreed(breed){

        var confirm = $mdDialog.confirm()
                               .title('Are you sure you would like to delete this breed?')
                               .textContent('Deleting the breed will remove all associated records.')
                               .ok('Cancel')
                               .cancel('Delete Breed');

        $mdDialog.show(confirm).then(function(){
          // Default Confirm is to cancel delete
        }, function() {
          // Delete Breed
          BreedsModel.deleteBreed(breed)
                      .then(function () {
                        ClientsModel.removeDogLocally(breed);
                        returnToBreeds(true);
                      });
        });

      };

      function cancelEditing() {
          returnToBreeds(false);
      }

      BreedsModel.getBreedById($stateParams.breedID)
                  .then(function (breed) {
                      if (breed) {
                          BreedsModel.setCurrentBreed(breed);
                      } else {
                          returnToBreeds(true);
                      }
                  });

      vm.cancelEditing = cancelEditing;
      vm.updateBreed = updateBreed;

  }); // end edit breed ctrl

}()); // end use strict

(function () {
  'use strict';

  angular.module('k9.breeds.create', [
    'ui.router',
    'k9.models.breeds'
  ])
  .config(function ($stateProvider) {

    //State Providers
    $stateProvider.state('k9.breeds.create',{
      url: '/breed/create',
      views: {
                'main@' : {
                            controller: 'CreateBreedController as vm',
                            templateUrl: 'app/breeds/create/breed-create.tmpl.html'
                          }
             }
    });

  })

  .controller('CreateBreedController', function($state, $stateParams, BreedsModel) {
    var vm = this;

    // Private
    function returnTobreeds(reload){
      $state.go('k9.settings.breeds', {}, { reload: reload });
    }

    function cancelCreating(){
      returnToBreeds(false);
    }

    function createBreed(breed){
      BreedsModel.createBreed(breed)
                  .then(function (breeds) {
                    BreedsModel.addBreed(breeds.data.breed);
                    $state.go('k9.breeds', {breedID: breeds.data.breed.id}, { reload: true });
                  });
    }

    function resetForm(){
      vm.newBreed = {
        name: ''
      };
    }

    // Public
    vm.cancel = cancelCreating;
    vm.createBreed = createBreed;

    // On Load
    resetForm();

  }); // end create breed ctrl

}()); // end use strict

(function () {
  'use strict';

  angular.module('k9.activities.edit', [
    'ui.router',
    'k9.models.activities'
  ])

  .controller('EditActivityController', function ($state, $stateParams, ClientsModel, ActivitiesModel,$mdDialog) {

      var vm = this;

      //Menu Icon Animation
      vm.clickIcon = 'menu';
      setTimeout(function(){
         vm.clickIcon = 'keyboard_backspace';
      }, 1);

      vm.editedActivity = ActivitiesModel.getCurrentActivity();

      function returnToActivities(reload) {
        ActivitiesModel.resetCurrentActivity();
        $state.go('k9.settings.activities', {}, { reload: false });
      }

      function updateActivity() {
        vm.activity = angular.copy(vm.editedActivity);
        ActivitiesModel.updateActivity(vm.editedActivity)
                    .then(function (activities) {
                      returnToActivities(true);
                    });
      }

      vm.deleteActivity = function deleteActivity(activity){

        var confirm = $mdDialog.confirm()
                               .title('Are you sure you would like to delete this activity?')
                               .textContent('Deleting the activity will remove all associated records.')
                               .ok('Cancel')
                               .cancel('Delete Activity');

        $mdDialog.show(confirm).then(function(){
          // Default Confirm is to cancel delete
        }, function() {
          // Delete Activity
          ActivitiesModel.deleteActivity(activity)
                      .then(function () {
                        ClientsModel.removeDogLocally(activity);
                        returnToActivities(true);
                      });
        });

      };

      function cancelEditing() {
          returnToActivities(false);
      }

      ActivitiesModel.getActivityById($stateParams.activityID)
                  .then(function (activity) {
                      if (activity) {
                          ActivitiesModel.setCurrentActivity(activity);
                      } else {
                          returnToActivities(true);
                      }
                  });

      vm.cancelEditing = cancelEditing;
      vm.updateActivity = updateActivity;

  }) // end edit activity ctrl

  .config(function ($stateProvider,$httpProvider,$urlRouterProvider) {

    //State Providers
    $stateProvider.state('k9.activities.edit',{
      url: '/activity/:activityID/edit',
      views: {
                'main@' : {
                            controller: 'EditActivityController as vm',
                            templateUrl: 'app/activities/edit/activity-edit.tmpl.html'
                          }
             }
    });

  });

}()); // end use strict

(function () {
  'use strict';

  angular.module('k9.activities.create', [
    'ui.router',
    'k9.models.activities'
  ])
  .config(function ($stateProvider) {

    //State Providers
    $stateProvider.state('k9.activities.create',{
      url: '/activity/create',
      views: {
                'main@' : {
                            controller: 'CreateActivityController as vm',
                            templateUrl: 'app/activities/create/activity-create.tmpl.html'
                          }
             }
    });

  })

  .controller('CreateActivityController', function($state, $stateParams, ActivitiesModel) {
    var vm = this;

    // Private
    function returnToactivities(reload){
      $state.go('k9.settings.activities', {}, { reload: reload });
    }

    function cancelCreating(){
      returnToActivities(false);
    }

    function createActivity(activity){
      ActivitiesModel.createActivity(activity)
                  .then(function (activities) {
                    ActivitiesModel.addActivity(activities.data.activity);
                    $state.go('k9.settings.activities', {activityID: activities.data.activity.id}, { reload: true });
                  });
    }

    function resetForm(){
      vm.newActivity = {
        name: ''
      };
    }

    // Public
    vm.cancel = cancelCreating;
    vm.createActivity = createActivity;

    // On Load
    resetForm();

  }); // end create activity ctrl

}()); // end use strict

(function () {
   'use strict';

   angular.module('k9.social',[
     'ui.router'
   ])

     .controller("SocialController",function PetCtrl(NavModel,$state,$mdDialog){

       //Public
       var vm = this;
       vm.toggleLeft    =   NavModel.buildDelayedToggler('left');

       updateNav();

       //Private
       function updateNav(){
         //Update Navigation State
         NavModel.setCurrentItem({
             title: 'Social Media',
             sref: 'k9.social'
         });
       }

     }) //end social controller

     .config(function config($stateProvider,$httpProvider,$urlRouterProvider){

       //State Providers
       $stateProvider.state('k9.social',{
         url: '/social',
         views: {
                   'main@' : {
                               controller: 'SocialController as vm',
                               templateUrl: 'app/social/social.tmpl.html'
                             },
                   'nav@' : {
                               controller: 'NavigationController as vm',
                               templateUrl: 'app/nav/nav.tmpl.html'
                             }
                },
          resolve: {
            // Page Title
            $title: function() { return 'Social'; }
          }
       });

     });

}()); //end use strict

(function() {
  'use strict';

  angular.module('k9.settings', [
    'ui.router'
  ])

  .controller("SettingController", function SettingCtrl(NavModel, $state, $mdDialog) {

      //Public
      var vm          =   this;
      vm.selectedTab  =   $state.current.data.selectedTab |= 0;
      vm.toggleLeft   =   NavModel.buildDelayedToggler('left');

      // On Load
      updateNav();

      //Private
      function updateNav() {
        //Update Navigation State
        NavModel.setCurrentItem({
          title: 'Settings',
          sref: 'k9.settings'
        });
      }

    }) //end setting controller

  .config(function config($stateProvider, $httpProvider, $urlRouterProvider) {

    //State Providers
    $stateProvider

    // Settings > Abstract Root Level
      .state('k9.settings', {
      abstract: true,
      url: '/settings',
      views: {
        'main@': {
          controller: 'SettingController as vm',
          templateUrl: 'app/settings/settings.tmpl.html'
        },
        'nav@': {
          controller: 'NavigationController as vm',
          templateUrl: 'app/nav/nav.tmpl.html'
        }
      }
    })

    // Settings > Breeds
    .state('k9.settings.breeds', {
      url: '/breeds',
      data: {
        'selectedTab': 0
      },
      views: {
        'breeds': {
          controller: 'BreedController as vm',
          templateUrl: 'app/settings/breeds/settings-breeds.tmpl.html'
        }
      }
    })

    // Settings > Activity
    .state('k9.settings.activities', {
      url: '/activities',
      data: {
        'selectedTab': 1
      },
      views: {
        'activities': {
          controller: 'ActivityController as vm',
          templateUrl: 'app/settings/activity/settings-activity.tmpl.html'
        }
      }
    });


  });

}()); //end use strict

(function() {
  'use strict';

  angular.module('k9.report', [
    'ui.router'
  ])

  .controller("ReportController",
      function ReportCtrl($http, appConfig, NavModel, $state, $mdDialog) {

        // Public
        var vm                    =   this;
        vm.showReport             =   showReport;
        vm.toggleLeft             =   NavModel.buildDelayedToggler('left');
        vm.createReportBtnLabel   =   '';
        vm.iconReportTitle        =   iconReportTitle;

        // State
        vm.isCreatingReport = false;
        vm.report = {
          reportType: 'Appointment'
        };

        // Onload
        updateNav();
        toggleCreatingReport(false);

        //Private
        function iconReportTitle(title) {
          var formattedTitle;
          var maxLength = 8;
          if (title.length > maxLength) {
            formattedTitle = title.substring(0, maxLength - 1) + '...';
          } else {
            formattedTitle = title + ' List';
          }
          return formattedTitle;
        }

        function toggleCreatingReport(on) {
          if (on) {
            vm.isCreatingReport = true;
            vm.createReportBtnLabel = 'Creating Report. Please wait...';
          } else {
            vm.isCreatingReport = false;
            vm.createReportBtnLabel = 'Download Report';
          }
        }

        function showReport(reportType) {

          toggleCreatingReport(true); //update state + labels

          //Report URL
          var reportURL = appConfig.API.baseURL + 'report/' +
            reportType + '.pdf';

          // Get file as blob and display
          // Based on http://stackoverflow.com/a/25808659
          // Cannot just open in new tab as need to pass
          // authentication headers and this is not possible by opening new tab
          $http.get(reportURL, {
              responseType: 'arraybuffer'
            })
            .success(function(data) {
              var file = new Blob([data], {
                type: 'application/pdf'
              });
              var fileURL = URL.createObjectURL(file);
              window.open(fileURL);
              toggleCreatingReport(false); //revert state
            });

        }

        function updateNav() {
          //Update Navigation State
          NavModel.setCurrentItem({
            title: 'Reports',
            sref: 'k9.report'
          });
        }

      }) //end report controller

  .config(function config($stateProvider, $httpProvider, $urlRouterProvider) {

    //State Providers
    $stateProvider.state('k9.report', {
      url: '/report',
      views: {
        'main@': {
          controller: 'ReportController as vm',
          templateUrl: 'app/reports/reports.tmpl.html'
        },
        'nav@': {
          controller: 'NavigationController as vm',
          templateUrl: 'app/nav/nav.tmpl.html'
        }
      },
      resolve: {
        // Page Title
        $title: function() {
          return 'Report';
        }
      }
    });

  });

}()); //end use strict

(function () {
  'use strict';

  angular.module('k9.register',['ui.router','ngMessages'])

    .controller("RegisterController",function RegisterCtrl(auth,$state,appConfig, $http, $q){

      //Public
      var isRegistering     =   false;
      var vm                =   this;
      vm.register           =   register;
      vm.isRegistering      =   getRegistering;
      vm.getRegisterMessage =   getRegisterMessage;
      vm.errorMessage       =   '';

      // Private
      function getRegistering(){
        return isRegistering;
      }

      function getRegisterMessage(){
          return (isRegistering) ? 'Creating Account. Please wait...' : 'Register Now';
      }

      function register(user){
        isRegistering = true;

        $http({
          method  : 'POST',
          url     : appConfig.API.baseURL +'users',
          data    : {
                      user: {
                        email     : user.email,
                        password  : user.password
                      }
                    }
        }).then(function successCallback(response) {
          // this callback will be called asynchronously
          // when the response is available

          // Attempt to Sign In user
          auth.login(user).then(
            function(response){
              localStorage.setItem('auth_token',response.data.token);
              localStorage.setItem('auth_email',response.data.email);
              isRegistering = false;
              $state.go('k9.dashboard');
            },
            function(response){
              vm.errorMessage = 'Account Registered but unable to sign in at this time.';
              isRegistering = false;
            }
          );

        }, function errorCallback(response) {
          // called asynchronously if an error occurs
          // or server returns response with an error status.
          vm.errorMessage = 'Unable to register account at this time';
          isRegistering = false;
        });

      }

    })


    .config(function config($stateProvider){

      $stateProvider.state('k9.register',{
        url: '/register',
        views: {
                  'main@' : {
                              controller: 'RegisterController as vm',
                              templateUrl: 'app/register/register.tmpl.html'
                            }
               },
         data : {
                    cssClassnames : 'page-register'
                }

      });

    });

}()); // end use strict

(function () {
   'use strict';

   angular.module('k9.profile',[
     'ui.router',
     'k9.models.nav',
     'k9.models.profiles'
   ])

     .controller("ProfileController",function ProfileCtrl(ProfilesModel,
       NavModel,$state,$mdDialog,$mdToast, $document){

       //Public
       var vm = this;
       vm.clickIcon           =   'keyboard_backspace';
       vm.toggleLeft          =   NavModel.buildDelayedToggler('left');
       vm.isLoading           =   isLoading;
       vm.isSaving            =   isSaving;
       vm.updateProfile       =   updateProfile;

       // On Load
       animateBackIcon();
       updateNav();
       getProfile();

       // Private
       var loading = true;
       var saving = false;

       //Update Navigation State
       function updateNav(){
         NavModel.setCurrentItem({
             title: 'Profile',
             sref: 'k9.profile'
         });
       }

       function updateProfile(profile){
         saving = true;
         ProfilesModel.updateProfile(profile)
                      .then(function (response) {

                        $mdToast.show(
                           $mdToast.simple()
                             .textContent('Profile Saved Successfully')
                             .position('top right')
                             .hideDelay(2400)
                             .parent('#profile-card')
                         );

                         saving = false;
                       });
       }

       function getProfile(){
         ProfilesModel.getProfile()
                      .then(function (response) {
                         var profile = response.data.profile;
                         ProfilesModel.setCurrentProfile(profile);
                         vm.profile = profile;
                         loading = false;
                       });
       }

       function isSaving(){
         return saving;
       }

       function isLoading(){
         return loading;
       }

       function animateBackIcon(){
         setTimeout(function(){
            vm.clickIcon = 'menu';
         }, 1);
       }

     }) //end profile controller

     .config(function config($stateProvider,$httpProvider,$urlRouterProvider){

       //State Providers
       $stateProvider.state('k9.profile',{
         url: '/profile',
         views: {
                   'main@' : {
                               controller: 'ProfileController as vm',
                               templateUrl: 'app/profiles/profiles.tmpl.html'
                             },
                   'nav@' : {
                               controller: 'NavigationController as vm',
                               templateUrl: 'app/nav/nav.tmpl.html'
                             }
                },
          resolve: {
            // Page Title
            $title: function() { return 'Profiles'; }
          }
       });

     });

}()); //end use strict

(function () {
   'use strict';

   angular.module('k9.pets',[
     'ui.router',
     'k9.models.pets',
     'k9.models.nav',
     'k9.pets.create',
     'k9.pets.edit'
   ])

     .controller("PetController",function PetCtrl(PetsModel,NavModel,$state,$mdDialog){

       //Public
       var vm = this;
       vm.clickIcon     =   'keyboard_backspace';
       vm.currentPet    =   PetsModel.getCurrentPet();
       vm.editPet       =   editPet;
       vm.searchActive  =   false;
       vm.toggleSearch  =   toggleSearch;
       vm.petSearchText =   '';
       vm.toggleLeft    =   NavModel.buildDelayedToggler('left');
       vm.isLoading     =   isLoading;

       animateBackIcon();
       getPets();
       updateNav();

       //Private
       var loading = true;

       function isLoading(){
         return loading;
       }

       function toggleSearch(searchOn){
         vm.searchActive = searchOn;
         if(!searchOn){
           vm.petSearchText = '';
         }
       }

       function animateBackIcon(){
         setTimeout(function(){
            vm.clickIcon = 'menu';
         }, 1);
       }

       function updateNav(){
         //Update Navigation State
         NavModel.setCurrentItem({
             title: 'Pets',
             sref: 'k9.pets'
         });
       }

       // Index
       function getPets(){
         loading = true;
         PetsModel.getPets()
                  .then(function (pets) {
                     vm.pets = pets;
                     loading = false;
                  });
       }

       // Go to edit
       function editPet(pet){
         $state.go('k9.pets.edit', { petID:pet.id} );
       }

     }) //end pet controller

     .config(function config($stateProvider,$httpProvider,$urlRouterProvider){

       //State Providers
       $stateProvider.state('k9.pets',{
         url: '/pets',
         views: {
                   'main@' : {
                               controller: 'PetController as vm',
                               templateUrl: 'app/pets/pets.tmpl.html'
                             },
                   'nav@' : {
                               controller: 'NavigationController as vm',
                               templateUrl: 'app/nav/nav.tmpl.html'
                             }
                },
          resolve: {
            // Page Title
            $title: function() { return 'Pets'; }
          }
       });

     });

}()); //end use strict

(function () {
  'use strict';

  angular.module('k9.login',['ui.router','ngMessages'])

    .controller("LoginController",function LoginCtrl(auth,$state){

      //Public
      var vm = this, isSigningIn;
      vm.login              =   login;
      vm.success            =   loginSuccess;
      vm.error              =   loginError;
      vm.isSigningIn        =   isSigningIn;
      vm.getSubmitMessage   =   getSubmitMessage;

      //Private
      function login(user){
        var promise = auth.login(user);
        isSigningIn = true;
        promise.then(vm.success, vm.error);
      }

      function loginSuccess(response){
        localStorage.setItem('auth_token',response.data.token);
        localStorage.setItem('auth_email',response.data.email);
        isSigningIn = false;
        $state.go('k9.dashboard');
      }

      function loginError(response){
        isSigningIn = false;
        vm.wrongCredentials = true;
      }

      function getSubmitMessage(){
        return (isSigningIn) ? ' Signing In. Please wait...' : 'Sign In' ;
      }

    })

    .config(function ($httpProvider){
      $httpProvider.interceptors.push('authInterceptor');
    })

    .factory('authInterceptor', function($q){
      return {
        request: function(config){
          config.headers = config.headers || {};
          if (localStorage.auth_token && localStorage.auth_email){
            config.headers.Authorization = 'Token token=' + localStorage.auth_token + ', email="' + localStorage.auth_email + '"';
          }
          return config;
        }
      };
    })

    .service('auth', function($http, appConfig){

      //Public
      var vm          =   this;
      vm.isLoggedIn   =   isLoggedIn;
      vm.logout       =   logout;
      vm.login        =   login;

      //Private
      function isLoggedIn(){
        return (localStorage.getItem('auth_token')) ? true : false;
      }

      function logout(){
        return 1;
      }

      function login(user){

        return $http.post(appConfig.API.baseURL + 'login', {
          user: {
                  email: user.email,
                  password: user.password
                }
        });

      }

    }) //end Login Controller

    .config(function config($stateProvider){

      $stateProvider.state('k9.login',{
        url: '/login',
        views: {
                  'main@' : {
                              controller: 'LoginController as vm',
                              templateUrl: 'app/login/login.tmpl.html'
                            }
               },
         data : {
                    cssClassnames : 'page-login'
                }

      });

    });

}()); // end use strict

(function () {
   'use strict';

   angular.module('k9.navigation',[
     'k9.models.nav'
   ])

     .controller("NavigationController",function NavigationController(NavModel,auth,$state,$window){

       //Public
       var vm = this;
       vm.menuItems           =   NavModel.getMenuItems();
       vm.isSelected          =   isSelected;
       vm.setCurrentItem      =   setCurrentItem;
       vm.logout              =   logout;
       vm.close               =   closeSideMenu;

       //Private

       function closeSideMenu(){
         NavModel.closeSideMenu();
       }

       function isSelected(menuItem){
         return NavModel.menuIsSelected(menuItem);
       }

       function setCurrentItem(menuItem){
         NavModel.setCurrentItem(menuItem);
       }

       function logout(){
         var promise = auth.logout();
         localStorage.removeItem('auth_token');
         localStorage.removeItem('auth_email');
         $state.go('k9.login');
         NavModel.closeSideMenu();
       }

     });

}()); // end use strict

(function () {
   'use strict';

    angular.module('k9.dashboard',[
      'ui.router',
      'k9.models.nav',
      'k9.models.calendar_events'
    ])

    .controller("DashboardController",function DashboardCtrl($scope, $timeout, $mdSidenav, $log, NavModel,$compile,calendarConfig,CalendarEventsModel, $mdDialog, $state){

      //Public
      var vm                     =   this;
      vm.calendarEvents          =   [];
      vm.eventSources            =   [vm.calendarEvents]; //cal sources
      vm.calendar                =   calendarConfig.defaults;
      vm.calendar.dayClick       =   calendarDayClick;
      vm.calendar.eventClick     =   calendarEventClick;
      vm.calendar.remove         =   calendarRemove;
      vm.calendar.changeView     =   calendarChangeView;
      vm.calendar.renderCalender =   calendarRender;
      vm.calendar.eventRender    =   calendarEventRender;
      vm.refreshCalendar         =   calendarRefresh;
      vm.toggleLeft              =   NavModel.buildDelayedToggler('left');
      vm.isSaving                =   isSaving;
      vm.isLoading               =   isLoading;

      vm.refreshCalendar();
      updateNav();

      //Private
      var saving  = false;
      var loading = true;

      function isSaving(){
        return saving;
      }

      function isLoading(){
        return loading;
      }

      /*
        Calendar - http://fullcalendar.io/
                 - http://angular-ui.github.io/ui-calendar
      */

      function calendarDayClick(date, jsEvent, view) {

        var calendarEvent = angular.copy(CalendarEventsModel.newCalendarEvent());
        calendarEvent.start = date;

        // If using month view there is no valid month,
        // update to use next hour
        if(view.name==='month'){
          calendarEvent.start = calendarEvent.start
                                             .startOf('day')
                                             .hours(moment().hours() + 1);
        }

        $mdDialog.show({
          controller    : 'CreateAppointmentController as vm',
          templateUrl   : 'app/dashboard/create/appointment-create.tmpl.html',
          parent        :  angular.element(document.body),
          targetEvent   : jsEvent,
          clickOutsideToClose:true,
          locals: {selectedDate: calendarEvent}
        })
        .then(function(appointment) {
          vm.refreshCalendar();
        }, function() {
          // Cancelled
        });

      }

      function calendarEventClick( date, jsEvent, view){
          $mdDialog.show({
            controller    : 'CreateAppointmentController as vm',
            templateUrl   : 'app/dashboard/create/appointment-create.tmpl.html',
            parent        :  angular.element(document.body),
            targetEvent   : jsEvent,
            clickOutsideToClose:true,
            locals: {selectedDate: date}
          })
          .then(function(answer) {
            vm.refreshCalendar();
          }, function() {
            // Cancelled
          });
      }

      function calendarRemove(index) {
        vm.calendar.events.splice(index,1);
      }

      // View changed
      function calendarChangeView(view,calendar) {
        uiCalendarConfig.calendars[calendar].fullCalendar('changeView',view);
      }

      // Calendar Rendered
      function calendarRender(calendar) {
        if(uiCalendarConfig.calendars[calendar]){
          uiCalendarConfig.calendars[calendar].fullCalendar('render');
        }
      }

      // Tooltip
      function calendarEventRender( event, element, view ) {
          element.attr({'tooltip': event.title,
                       'tooltip-append-to-body': true});
          $compile(element)(vm.calendar);
      }

      function calendarRefresh(){
        loading = true;
        CalendarEventsModel.getCalendarEvents()
          .then(function (calendarEvents) {

            // Important note about the below. Must empty array,
            // not replace it due to watcher and references
            // more info: http://stackoverflow.com/a/24051140/3807889

            // Remove items without breaking reference
            vm.calendarEvents.splice(0, vm.calendarEvents.length);

            // Build up custom event object and push to array
            // Note the stick: true setting which is required to fix rendering bug
            angular.forEach(calendarEvents,function(event, key){

              var newEvent = {
                id: event.id,
                title: event.title,
                start: event.start,
                end: event.end,
                allDay: event.allDay,
                stick: true,
                color: '#C2185B',
                dog: event.dog,
                activity: event.activity,
                charge: parseFloat(event.charge)
              };

              vm.calendarEvents.push(newEvent);

            });

            // Loading Complete
            loading = false;

          });
      }

      function updateNav(){
        NavModel.setCurrentItem({
            title: 'Dashboard',
            sref: 'k9.dashboard'
        });
      }

    })

    //Routes
    .config(function config($stateProvider){

      //State Providers
      $stateProvider.state('k9.dashboard',{
        url: '/dashboard',
        views: {
                  'main@' : {
                              controller: 'DashboardController as vm',
                              templateUrl: 'app/dashboard/dashboard.tmpl.html'
                            },
                  'nav@' : {
                              controller: 'NavigationController as vm',
                              templateUrl: 'app/nav/nav.tmpl.html'
                            }
               },
           resolve: {
             // Page Title
             $title: function() { return 'Dashboard'; }
           },
           data : {
                      cssClassnames : 'page-dashboard'
                  }
      });

    });

}()); // end use strict

(function() {
  'use strict';

  angular
    .module('k9')

    // Common directive for Focus
    .directive('focus',
      function($timeout) {
        return {
          scope : {
            trigger : '@focus'
          },
          link : function(scope, element) {
            scope.$watch('trigger', function(value) {
              if (value === "true") {
                $timeout(function() {
                  element[0].focus();
                });
              }
            });
          }
        };
      }
    );

    /** @ngInject */

})();

(function () {
   'use strict';

   angular.module('k9.clients',[
     'ui.router',
     'k9.models.clients',
     'k9.models.nav',
     'k9.clients.create',
     'k9.clients.edit'
   ])

     .controller("ClientController",function ClientCtrl(ClientsModel,NavModel,$state,$mdDialog){

       //Public
       var vm = this;
       vm.currentClient     =   ClientsModel.getCurrentClient();
       vm.editClient        =   editClient;
       vm.viewClient        =   viewClient;
       vm.searchActive      =   false;
       vm.toggleSearch      =   toggleSearch;
       vm.clientSearchText  =   '';
       vm.toggleLeft        =   NavModel.buildDelayedToggler('left');
       vm.isLoading         =   isLoading;

       getClients();
       updateNav();

       //Private
       var loading = true;

       function isLoading(){
         return loading;
       }

       function toggleSearch(searchOn){
         vm.searchActive = searchOn;
         if(!searchOn){
           //Reset search if user turns off search
           vm.clientSearchText = '';
         }
       }

       //Update Navigation State
       function updateNav(){
         NavModel.setCurrentItem({
             title: 'Clients',
             sref: 'k9.clients'
         });
       }

       // Index
       function getClients(){
         loading = true;

         ClientsModel.getClients()
                     .then(function (clients) {
                       vm.clients = clients;
                       loading = false;
                     });
       }

       // Go to edit
       function editClient(client){
         $state.go('k9.clients.edit', { clientID:client.id} );
       }

       // Go to view
       function viewClient(client){
         $state.go('k9.clients.view', { clientID:client.id} );
       }

     }) //end client ctrl

     //Routes
     .config(function config($stateProvider,$httpProvider,$urlRouterProvider){

       //State Providers
       $stateProvider.state('k9.clients',{
         url: '/clients',
         views: {
                   'main@' : {
                               controller: 'ClientController as vm',
                               templateUrl: 'app/clients/clients.tmpl.html'
                             },
                   'nav@' : {
                               controller: 'NavigationController as vm',
                               templateUrl: 'app/nav/nav.tmpl.html'
                             }
                },
          resolve: {
            // Page Title
            $title: function() { return 'Clients'; }
          }
       });

     });

}()); //end use strict

(function () {
   'use strict';

   angular.module('k9.breeds',[
     'ui.router',
     'k9.models.nav',
     'k9.breeds.create',
     'k9.breeds.edit',
     'k9.models.breeds'
   ])

     .controller("BreedController",function BreedCtrl(BreedsModel,NavModel,$state,$mdDialog){

       //Public
       var vm = this;
       vm.clickIcon       =   'keyboard_backspace';
       vm.currentBreed    =   BreedsModel.getCurrentBreed();
       vm.editBreed       =   editBreed;
       vm.searchActive    =   false;
       vm.toggleSearch    =   toggleSearch;
       vm.breedSearchText =   '';
       vm.toggleLeft      =   NavModel.buildDelayedToggler('left');
       vm.isLoading       =   isLoading;

      //  On Load
       animateBackIcon();
       getBreeds();
       updateNav();

       //Private
       var loading = true;

       function isLoading(){
         return loading;
       }

       function toggleSearch(searchOn){
         vm.searchActive = searchOn;
         if(!searchOn){
           vm.breedSearchText = '';
         }
       }

       function animateBackIcon(){
         setTimeout(function(){
            vm.clickIcon = 'menu';
         }, 1);
       }

       function updateNav(){
         //Update Navigation State
         NavModel.setCurrentItem({
             title: 'Settings',
             sref: 'k9.breeds'
         });
       }

       // Index
       function getBreeds(){
         loading = true;
         BreedsModel.getBreeds()
                  .then(function (breeds) {
                     vm.breeds = breeds;
                     loading = false;
                  });
       }

       // Go to edit
       function editBreed(breed){
         $state.go('k9.breeds.edit', { breedID:breed.id} );
       }

     }) //end breed controller

     .config(function config($stateProvider,$httpProvider,$urlRouterProvider){

       //State Providers
       $stateProvider.state('k9.breeds',{
         url: '/breeds',
         views: {
                   'main@' : {
                               controller: 'BreedController as vm',
                               templateUrl: 'app/breeds/breeds.tmpl.html'
                             },
                   'nav@' : {
                               controller: 'NavigationController as vm',
                               templateUrl: 'app/nav/nav.tmpl.html'
                             }
                },
          resolve: {
            // Page Title
            $title: function() { return 'Breeds'; }
          }
       });

     });

}()); //end use strict

(function () {
   'use strict';

   angular.module('k9.activities',[
     'ui.router',
     'k9.models.nav',
     'k9.activities.create',
     'k9.activities.edit',
     'k9.models.activities'
   ])

     .controller("ActivityController",function ActivityCtrl(ActivitiesModel,NavModel,$state,$mdDialog){

       //Public
       var vm = this;
       vm.clickIcon           =   'keyboard_backspace';
       vm.currentActivity     =   ActivitiesModel.getCurrentActivity();
       vm.editActivity        =   editActivity;
       vm.searchActive        =   false;
       vm.toggleSearch        =   toggleSearch;
       vm.activitySearchText  =   '';
       vm.toggleLeft          =   NavModel.buildDelayedToggler('left');
       vm.isLoading       =   isLoading;

       animateBackIcon();
       getActivities();
       updateNav();

       //Private
       var loading = true;

       function isLoading(){
         return loading;
       }

       function toggleSearch(searchOn){
         vm.searchActive = searchOn;
         if(!searchOn){
           vm.activitySearchText = '';
         }
       }

       function animateBackIcon(){
         setTimeout(function(){
            vm.clickIcon = 'menu';
         }, 1);
       }

       function updateNav(){
         //Update Navigation State
         NavModel.setCurrentItem({
             title: 'Settings',
             sref: 'k9.activities'
         });
       }

       // Index
       function getActivities(){
         loading = true;
         ActivitiesModel.getActivities()
                  .then(function (activities) {
                     vm.activities = activities;
                     loading = false;
                  });
       }

       // Go to edit
       function editActivity(activity){
         $state.go('k9.activities.edit', { activityID:activity.id} );
       }

     }) //end activity controller

     .config(function config($stateProvider,$httpProvider,$urlRouterProvider){

       //State Providers
       $stateProvider.state('k9.activities',{
         url: '/activities',
         views: {
                   'main@' : {
                               controller: 'ActivityController as vm',
                               templateUrl: 'app/activities/activities.tmpl.html'
                             },
                   'nav@' : {
                               controller: 'NavigationController as vm',
                               templateUrl: 'app/nav/nav.tmpl.html'
                             }
                },
          resolve: {
            // Page Title
            $title: function() { return 'Activities'; }
          }
       });

     });

}()); //end use strict

(function() {
  'use strict';

  angular
    .module('k9')
    .run(runBlock)
    .run(k9AuthCheck);

  /** @ngInject */
  function runBlock($log) {
    $log.debug('runBlock end');
  }

  function k9AuthCheck($rootScope, $state, $location, auth) {
    // http://stackoverflow.com/a/27215254
    // http://plnkr.co/edit/3kImqU?p=preview

    $rootScope.$on('$stateChangeStart', function (event, toState, toParams, fromState) {

      if(!auth.isLoggedIn()){

        var onLoginPage = toState.name === "k9.login";
        var onRegisterPage = toState.name === "k9.register";

        if(!onLoginPage && !onRegisterPage){
          event.preventDefault(); // stop current execution
          $state.go('k9.login');  // go to login
        }

      }else{
        //Redirect code: http://stackoverflow.com/a/29491412
        if (toState.redirectTo) {
          event.preventDefault();
          $state.go(toState.redirectTo, toParams);
        }
      }

    });

  }

})();

(function() {
  'use strict';

  angular
    .module('k9')
    .config(routerConfig);

  /** @ngInject */
  function routerConfig($stateProvider, $urlRouterProvider, $locationProvider) {

    $stateProvider.state('k9',{
      url: '',
      redirectTo: 'k9.dashboard'
    });

    $urlRouterProvider.otherwise("/login");

    $locationProvider.html5Mode(false); //removes the hash url in supported browsers
  }

})();

/* global moment:false */
(function() {
  'use strict';

  var development = false;
  var baseURL = development ? 'http://www.k9.dev/api/v1/' : 'https://k9g.herokuapp.com/api/v1/';

  angular
    .module('k9')
    .constant('moment', moment)
    .constant('appConfig', {
      'API' : {
                   'baseURL' : baseURL
              }
    })
    .constant('calendarConfig', {
      'defaults' : {
                        height: 'auto', //620
                        editable: true,
                        header:{
                          left: 'title',
                          center: 'agendaDay, agendaWeek, month', //agendaWeek, agendaDay
                          right: 'today prev,next'
                        },
                        allDaySlot: false,
                        defaultView: 'month',
                        buttonText: {
                                        today:    'Today',
                                        month:    'Month',
                                        week:     'Week',
                                        day:      'Day',
                                        agendaWeek: 'Week'
                                    }
                      }
    });

})();

(function() {
  'use strict';

  angular
    .module('k9')
    .config(config)
    .config(function($mdDateLocaleProvider) {
        //Default date format
        $mdDateLocaleProvider.formatDate = function(date) {
           return moment(date).format('DD-MM-YYYY');
        };
    })
    .config(function($mdThemingProvider, $mdIconProvider){
        // Update the theme colors to use themes on font-icons

        $mdThemingProvider.theme('default')
              .primaryPalette("blue")
              .accentPalette('amber')
              .warnPalette('red')
              .backgroundPalette('grey');

        $mdThemingProvider.theme('night')
              .primaryPalette("pink")
              .accentPalette('amber')
              .warnPalette('red')
              .backgroundPalette('grey');
  });

  /** @ngInject */
  function config($logProvider) {
    // Enable log
    $logProvider.debugEnabled(true);
  }

})();

angular.module("k9").run(["$templateCache", function($templateCache) {$templateCache.put("app/activities/activities.tmpl.html","<md-toolbar ng-show=\"!vm.searchActive\"><div class=\"md-toolbar-tools\"><md-button ng-click=\"vm.toggleLeft()\" hide-gt-md=\"\" class=\"md-icon-button\" aria-label=\"Menu\"><ng-md-icon ng-click=\"vm.clickIconMorph()\" icon=\"{{ vm.clickIcon }}\" options=\'{ \"easing\": \"quad-out\", \"duration\": 500 }\' size=\"24\"></ng-md-icon></md-button><h2><span>Activities</span></h2><span flex=\"\"></span><md-button type=\"button\" class=\"md-icon-button\" ng-click=\"vm.toggleSearch(true)\" aria-label=\"Search Activities\"><md-tooltip md-direction=\"bottom\">Search Activities</md-tooltip><ng-md-icon icon=\"search\" size=\"24\"></ng-md-icon></md-button></div></md-toolbar><md-toolbar class=\"md-hue-1\" ng-show=\"vm.searchActive\"><div class=\"md-toolbar-tools\"><md-button type=\"button\" class=\"md-icon-button\" ng-click=\"vm.toggleSearch(false)\" aria-label=\"Back\"><md-tooltip md-direction=\"bottom\">Back</md-tooltip><ng-md-icon icon=\"arrow_back\" size=\"24\"></ng-md-icon></md-button><h3 flex=\"10\">Back</h3><md-input-container flex=\"\"><label></label> <input ng-model=\"vm.activitySearchText\" focus=\"true\" placeholder=\"enter search\"></md-input-container><md-button type=\"button\" class=\"md-icon-button\" aria-label=\"Search\"><md-tooltip md-direction=\"bottom\">Search</md-tooltip><ng-md-icon icon=\"search\" size=\"24\"></ng-md-icon></md-button></div></md-toolbar><k9-full-page-loader ng-show=\"vm.isLoading()\"></k9-full-page-loader><md-content flex=\"\" id=\"content\"><div class=\"activities-list\"><div ng-show=\"(vm.activities | filter:vm.activitySearchText).length < 1\" class=\"alert alert-info text-center\" role=\"alert\"><p>There are no activities yet. You can add your first activity by clicking the Add Activity button below.</p></div><div ng-hide=\"(vm.activities | filter:vm.activitySearchText).length < 1\"><md-content class=\"search-results\" flex=\"\" layout-padding=\"\"><md-list-item ng-click=\"vm.editActivity(activity)\" ng-repeat=\"activity in vm.activities | filter:vm.activitySearchText\"><ng-md-icon icon=\"paw\" size=\"24\"></ng-md-icon><p>{{ activity.description }}</p><ng-md-icon icon=\"chevron_right\" size=\"24\"></ng-md-icon></md-list-item></md-content></div></div></md-content><button class=\"md-fab md-fab-bottom-right md-button md-default-theme\" ui-sref=\"k9.activities.create\" aria-label=\"Add\" tabindex=\"0\"><ng-md-icon icon=\"add\" size=\"24\"></ng-md-icon><md-tooltip>Add Activity</md-tooltip></button>");
$templateCache.put("app/breeds/breeds.tmpl.html","<md-toolbar ng-show=\"!vm.searchActive\"><div class=\"md-toolbar-tools\"><md-button ng-click=\"vm.toggleLeft()\" hide-gt-md=\"\" class=\"md-icon-button\" aria-label=\"Menu\"><ng-md-icon ng-click=\"vm.clickIconMorph()\" icon=\"{{ vm.clickIcon }}\" options=\'{ \"easing\": \"quad-out\", \"duration\": 500 }\' size=\"24\"></ng-md-icon></md-button><h2><span>Breeds</span></h2><span flex=\"\"></span><md-button type=\"button\" class=\"md-icon-button\" ng-click=\"vm.toggleSearch(true)\" aria-label=\"Search Breeds\"><md-tooltip md-direction=\"bottom\">Search Breeds</md-tooltip><ng-md-icon icon=\"search\" size=\"24\"></ng-md-icon></md-button></div></md-toolbar><md-toolbar class=\"md-hue-1\" ng-show=\"vm.searchActive\"><div class=\"md-toolbar-tools\"><md-button type=\"button\" class=\"md-icon-button\" ng-click=\"vm.toggleSearch(false)\" aria-label=\"Back\"><md-tooltip md-direction=\"bottom\">Back</md-tooltip><ng-md-icon icon=\"arrow_back\" size=\"24\"></ng-md-icon></md-button><h3 flex=\"10\">Back</h3><md-input-container flex=\"\"><label></label> <input ng-model=\"vm.breedSearchText\" focus=\"true\" placeholder=\"enter search\"></md-input-container><md-button type=\"button\" class=\"md-icon-button\" aria-label=\"Search\"><md-tooltip md-direction=\"bottom\">Search</md-tooltip><ng-md-icon icon=\"search\" size=\"24\"></ng-md-icon></md-button></div></md-toolbar><k9-full-page-loader ng-show=\"vm.isLoading()\"></k9-full-page-loader><md-content flex=\"\" id=\"content\"><div class=\"breeds-list\"><div ng-show=\"(vm.breeds | filter:vm.breedSearchText).length < 1\" class=\"alert alert-info text-center\" role=\"alert\"><p>There are no breeds yet. You can add your first breed by clicking the Add Breed button below.</p></div><div ng-hide=\"(vm.breeds | filter:vm.breedSearchText).length < 1\"><md-content class=\"search-results\" flex=\"\" layout-padding=\"\"><md-list-item ng-click=\"vm.editBreed(breed)\" ng-repeat=\"breed in vm.breeds | filter:vm.breedSearchText\"><ng-md-icon icon=\"paw\" size=\"24\"></ng-md-icon><p>{{ breed.name }}</p><ng-md-icon icon=\"chevron_right\" size=\"24\"></ng-md-icon></md-list-item></md-content></div></div></md-content><button class=\"md-fab md-fab-bottom-right md-button md-default-theme\" ui-sref=\"k9.breeds.create\" aria-label=\"Add\" tabindex=\"0\"><ng-md-icon icon=\"add\" size=\"24\"></ng-md-icon><md-tooltip>Add Breed</md-tooltip></button>");
$templateCache.put("app/clients/clients.tmpl.html","<md-toolbar ng-show=\"!vm.searchActive\"><div class=\"md-toolbar-tools\"><md-button ng-click=\"vm.toggleLeft()\" hide-gt-md=\"\" class=\"md-icon-button\" aria-label=\"Menu\"><ng-md-icon icon=\"menu\" size=\"24\"></ng-md-icon></md-button><h2><span>Clients</span></h2><span flex=\"\"></span><md-button type=\"button\" class=\"md-icon-button\" ng-click=\"vm.toggleSearch(true)\" aria-label=\"Search Pets\"><md-tooltip md-direction=\"bottom\">Search Pets</md-tooltip><ng-md-icon icon=\"search\" size=\"24\"></ng-md-icon></md-button></div></md-toolbar><md-toolbar class=\"md-hue-1\" ng-show=\"vm.searchActive\"><div class=\"md-toolbar-tools\"><md-button type=\"button\" class=\"md-icon-button\" ng-click=\"vm.toggleSearch(false)\" aria-label=\"Back\"><md-tooltip md-direction=\"bottom\">Back</md-tooltip><ng-md-icon icon=\"arrow_back\" size=\"24\"></ng-md-icon></md-button><h3 flex=\"10\">Back</h3><md-input-container flex=\"\"><label></label> <input ng-model=\"vm.clientSearchText\" focus=\"true\" placeholder=\"enter search\"></md-input-container><md-button type=\"button\" class=\"md-icon-button\" aria-label=\"Search\"><md-tooltip md-direction=\"bottom\">Search</md-tooltip><ng-md-icon icon=\"search\" size=\"24\"></ng-md-icon></md-button></div></md-toolbar><k9-full-page-loader ng-show=\"vm.isLoading()\"></k9-full-page-loader><md-content flex=\"\" id=\"content\" class=\"view-port-list\"><div class=\"clients-list\"><div ng-show=\"(vm.clients | filter:vm.clientSearchText).length < 1\" class=\"alert alert-info text-center\" role=\"alert\"><p>There are no clients yet. You can add your first client by clicking the Add Client button below.</p></div><div ng-hide=\"(vm.clients | filter:vm.clientSearchText).length < 1\"><md-content class=\"search-results\" flex=\"\" layout-padding=\"\"><md-list-item ng-click=\"vm.viewClient(client)\" ng-repeat=\"client in vm.clients | filter:vm.clientSearchText\"><k9-client-thumb></k9-client-thumb><p>{{ client.first_name }} {{ client.last_name }}<br>Dogs: {{ client.dogs.length }}</p><ng-md-icon icon=\"chevron_right\" size=\"24\"></ng-md-icon></md-list-item></md-content></div></div></md-content><button class=\"md-fab md-fab-bottom-right md-button md-default-theme\" ui-sref=\"k9.clients.create\" aria-label=\"Add\" tabindex=\"0\"><ng-md-icon icon=\"person_add\" size=\"24\"></ng-md-icon><md-tooltip>Add Client</md-tooltip></button>");
$templateCache.put("app/dashboard/dashboard.tmpl.html","<md-toolbar><div class=\"md-toolbar-tools\"><md-button ng-click=\"vm.toggleLeft()\" hide-gt-md=\"\" class=\"md-icon-button\" aria-label=\"Menu\"><ng-md-icon icon=\"menu\" size=\"24\"></ng-md-icon></md-button><h2><span>Dashboard</span></h2></div></md-toolbar><div class=\"progress-linear-holder\"><md-progress-linear md-mode=\"indeterminate\" ng-show=\"vm.isLoading() || isSaving()\" class=\"md-accent\"></md-progress-linear></div><md-content flex=\"\" layout-padding=\"\"><div><div ui-calendar=\"vm.calendar\" ng-model=\"vm.eventSources\"></div><div class=\"calendar-status\" ng-show=\"vm.isLoading()\">Retrieving Latest Appointments . . .</div></div></md-content>");
$templateCache.put("app/login/login.tmpl.html","<md-toolbar class=\"k9-login\"><div class=\"md-toolbar-tools\"><span flex=\"\"></span><h2><span class=\"title\">GroomK9</span><ng-md-icon class=\"siteicon\" icon=\"paw\" size=\"12\"></ng-md-icon><span class=\"com\">com</span></h2><span flex=\"\"></span></div></md-toolbar><md-content flex=\"\" class=\"k9-login main-content\"><div class=\"loginForm\" layout=\"column\" ng-cloak=\"\"><md-content layout-padding=\"\"><md-card><md-card-title><md-card-title-text><span class=\"md-headline\">Sign In Form</span></md-card-title-text></md-card-title><form ng-submit=\"vm.login(user)\" novalidate=\"\" name=\"loginForm\"><md-input-container md-no-float=\"\" class=\"md-block\"><label>E-mail</label><md-icon md-svg-src=\"app/assets/img/icons/ic_email_24px.svg\" style=\"display:inline-block;\"></md-icon><input ng-model=\"user.email\" type=\"email\" name=\"email\" ng-required=\"true\" rm-focus=\"\"><div ng-show=\"loginForm.email.$dirty\" ng-messages=\"loginForm.email.$error\"><div ng-message=\"required\">An e-mail address must be entered</div><div ng-message=\"email\">E-mail address is not valid</div><div ng-message-exp=\"vm.wrongCredentials\">WRONG DETAILS!</div></div></md-input-container><md-input-container md-no-float=\"\" class=\"md-block\"><label>Password</label><md-icon md-svg-src=\"app/assets/img/icons/ic_lock_24px.svg\" style=\"display:inline-block;\"></md-icon><input type=\"password\" name=\"password\" ng-model=\"user.password\" required=\"\"><div ng-show=\"loginForm.password.$dirty\" ng-messages=\"loginForm.password.$error\"><div ng-message=\"required\">Password is required</div></div></md-input-container><div ng-show=\"vm.wrongCredentials\">The email and password you entered don\'t match.</div><md-card-actions layout=\"column\" layout-align=\"center center\"><md-button flex=\"\" ng-disabled=\"loginForm.$invalid || vm.isSigningIn()\" ng-click=\"vm.login(user)\" class=\"md-raised md-primary\">{{ vm.getSubmitMessage() }}</md-button></md-card-actions><div class=\"alt-action\"><a flex=\"\" ui-sref=\"k9.register\">Create New Account</a></div></form></md-card></md-content></div></md-content>");
$templateCache.put("app/nav/nav.tmpl.html","<md-toolbar class=\"k9-nav md-theme-indigo\"><h1 class=\"md-toolbar-tools\"><span class=\"title\">GroomK9</span><ng-md-icon class=\"siteicon\" icon=\"paw\" size=\"12\"></ng-md-icon><span class=\"com\">com</span></h1></md-toolbar><md-content class=\"k9-nav\"><md-list><md-list-item ng-repeat=\"menuItem in vm.menuItems\"><md-button ui-sref=\"{{ menuItem.sref }}\" ng-click=\"vm.close()\" ng-class=\"{\'selected\' : vm.isSelected(menuItem) }\"><ng-md-icon icon=\"{{ menuItem.icon }}\" size=\"24\"></ng-md-icon>{{ menuItem.title }}</md-button></md-list-item><md-list-item><md-button ng-click=\"vm.logout()\"><ng-md-icon icon=\"exit_to_app\" size=\"24\"></ng-md-icon>Sign Out</md-button></md-list-item></md-list></md-content>");
$templateCache.put("app/pets/pets.tmpl.html","<md-toolbar ng-show=\"!vm.searchActive\"><div class=\"md-toolbar-tools\"><md-button ng-click=\"vm.toggleLeft()\" hide-gt-md=\"\" class=\"md-icon-button\" aria-label=\"Menu\"><ng-md-icon ng-click=\"vm.clickIconMorph()\" icon=\"{{ vm.clickIcon }}\" options=\'{ \"easing\": \"quad-out\", \"duration\": 500 }\' size=\"24\"></ng-md-icon></md-button><h2><span>Pets</span></h2><span flex=\"\"></span><md-button type=\"button\" class=\"md-icon-button\" ng-click=\"vm.toggleSearch(true)\" aria-label=\"Search Pets\"><md-tooltip md-direction=\"bottom\">Search Pets</md-tooltip><ng-md-icon icon=\"search\" size=\"24\"></ng-md-icon></md-button></div></md-toolbar><md-toolbar class=\"md-hue-1\" ng-show=\"vm.searchActive\"><div class=\"md-toolbar-tools\"><md-button type=\"button\" class=\"md-icon-button\" ng-click=\"vm.toggleSearch(false)\" aria-label=\"Back\"><md-tooltip md-direction=\"bottom\">Back</md-tooltip><ng-md-icon icon=\"arrow_back\" size=\"24\"></ng-md-icon></md-button><h3 flex=\"10\">Back</h3><md-input-container flex=\"\"><label></label> <input ng-model=\"vm.petSearchText\" focus=\"true\" placeholder=\"enter search\"></md-input-container><md-button type=\"button\" class=\"md-icon-button\" aria-label=\"Search\"><md-tooltip md-direction=\"bottom\">Search</md-tooltip><ng-md-icon icon=\"search\" size=\"24\"></ng-md-icon></md-button></div></md-toolbar><k9-full-page-loader ng-show=\"vm.isLoading()\"></k9-full-page-loader><md-content flex=\"\" id=\"content\" class=\"view-port-list\"><div class=\"pets-list\"><div ng-show=\"(vm.pets | filter:vm.petSearchText).length < 1\" class=\"alert alert-info text-center\" role=\"alert\"><p>There are no pets yet. You can add your first pet by clicking the Add Pet button below.</p></div><div ng-hide=\"(vm.pets | filter:vm.petSearchText).length < 1\"><md-content class=\"search-results\" flex=\"\" layout-padding=\"\"><md-list-item ng-click=\"vm.editPet(pet)\" aria-label=\"View Pet {{ pet.name }}\" ng-repeat=\"pet in vm.pets | filter:vm.petSearchText\"><div class=\"blank_list_thumb\" ng-hide=\"pet.photos.length > 0\"><span>{{ pet.name.charAt(0) }}</span></div><img ng-src=\"{{ pet.photos[pet.photos.length - 1].thumbnail_menu }}\" class=\"md-card-image\" alt=\"{{ photo.title }}\" aria-label=\"{{ photo.title }}\" ng-show=\"pet.photos.length > 0\" layout-padding=\"\"><p>{{ pet.name }}</p><ng-md-icon icon=\"chevron_right\" size=\"24\"></ng-md-icon></md-list-item></md-content></div></div></md-content><button class=\"md-fab md-fab-bottom-right md-button md-default-theme\" ui-sref=\"k9.pets.create\" aria-label=\"Add\" tabindex=\"0\"><ng-md-icon icon=\"add\" size=\"24\"></ng-md-icon><md-tooltip>Add Pet</md-tooltip></button>");
$templateCache.put("app/profiles/profiles.tmpl.html","<md-toolbar ng-show=\"!vm.searchActive\"><div class=\"md-toolbar-tools\"><md-button ng-click=\"vm.toggleLeft()\" hide-gt-md=\"\" class=\"md-icon-button\" aria-label=\"Menu\"><ng-md-icon ng-click=\"vm.clickIconMorph()\" icon=\"{{ vm.clickIcon }}\" options=\'{ \"easing\": \"quad-out\", \"duration\": 500 }\' size=\"24\"></ng-md-icon></md-button><h2><span>Profile</span></h2><span flex=\"\"></span><md-progress-circular md-mode=\"indeterminate\" class=\"md-accent\" ng-show=\"vm.isSaving()\"></md-progress-circular><md-button type=\"submit\" class=\"md-icon-button\" aria-label=\"Save Profile\" ng-hide=\"vm.isSaving()\" ng-click=\"vm.updateProfile(vm.profile)\"><md-tooltip md-direction=\"bottom\">Save Profile</md-tooltip><ng-md-icon icon=\"done\" size=\"24\"></ng-md-icon></md-button></div></md-toolbar><k9-full-page-loader ng-show=\"vm.isLoading()\"></k9-full-page-loader><md-card id=\"profile-card\"><form ng-submit=\"vm.updateProfile(vm.profile)\" class=\"md-padding\"><md-card-title><md-card-title-text><span class=\"md-headline\">{{ vm.profile.name }}</span> <span class=\"md-subhead\">My Details</span></md-card-title-text></md-card-title><md-input-container class=\"md-icon-float md-block\"><label>Name</label><md-icon md-svg-src=\"app/assets/img/icons/ic_assignment_ind_24px.svg\" class=\"name\"></md-icon><input ng-model=\"vm.profile.name\" type=\"text\"></md-input-container><md-input-container md-no-float=\"\" class=\"md-block\"><label>Phone</label><md-icon md-svg-src=\"app/assets/img/icons/ic_phone_24px.svg\"></md-icon><input ng-model=\"vm.profile.phone\" type=\"tel\"></md-input-container><md-input-container md-no-float=\"\" class=\"md-block\"><label>Mobile</label><md-icon md-svg-src=\"app/assets/img/icons/ic_smartphone_24px.svg\"></md-icon><input ng-model=\"vm.profile.mobile\" type=\"tel\"></md-input-container><md-input-container class=\"md-block\"><label>Email</label><md-icon md-svg-src=\"app/assets/img/icons/ic_email_24px.svg\" class=\"email\"></md-icon><input ng-model=\"vm.profile.email\" type=\"email\"></md-input-container><md-input-container class=\"md-block\"><label>Website</label><md-icon md-svg-src=\"app/assets/img/icons/ic_home_24px.svg\" class=\"email\"></md-icon><input ng-model=\"vm.profile.website\" type=\"url\"></md-input-container><md-input-container md-no-float=\"\" class=\"md-block\"><label>Address</label><md-icon md-svg-src=\"app/assets/img/icons/ic_place_24px.svg\" style=\"display:inline-block;\"></md-icon><input ng-model=\"vm.profile.address\" type=\"text\"></md-input-container><md-input-container md-no-float=\"\" class=\"md-block\"><label>Tax Number</label><md-icon md-svg-src=\"app/assets/img/icons/ic_receipt_24px.svg\" style=\"display:inline-block;\"></md-icon><input ng-model=\"vm.profile.tax_number\" type=\"text\"></md-input-container></form></md-card>");
$templateCache.put("app/register/register.tmpl.html","<md-toolbar class=\"k9-register\"><div class=\"md-toolbar-tools\"><span flex=\"\"></span><h2><span class=\"title\">GroomK9</span><ng-md-icon class=\"siteicon\" icon=\"paw\" size=\"12\"></ng-md-icon><span class=\"com\">com</span></h2><span flex=\"\"></span></div></md-toolbar><md-content flex=\"\" class=\"k9-login main-content\"><div class=\"loginForm\" layout=\"column\" ng-cloak=\"\"><md-content layout-padding=\"\"><md-card><md-card-title><md-card-title-text><span class=\"md-headline\">Registration Form</span></md-card-title-text></md-card-title><form ng-submit=\"vm.register(user)\" novalidate=\"\" name=\"registerForm\"><md-input-container md-no-float=\"\" class=\"md-block\"><label>E-mail</label><md-icon md-svg-src=\"app/assets/img/icons/ic_email_24px.svg\" style=\"display:inline-block;\"></md-icon><input ng-model=\"user.email\" type=\"email\" name=\"email\" ng-required=\"true\" rm-focus=\"\"><div ng-show=\"loginForm.email.$dirty\" ng-messages=\"loginForm.email.$error\"><div ng-message=\"required\">An e-mail address must be entered</div><div ng-message=\"email\">E-mail address is not valid</div><div ng-message-exp=\"vm.wrongCredentials\">WRONG DETAILS!</div></div></md-input-container><md-input-container md-no-float=\"\" class=\"md-block\"><label>Password</label><md-icon md-svg-src=\"app/assets/img/icons/ic_lock_24px.svg\" style=\"display:inline-block;\"></md-icon><input type=\"password\" name=\"password\" ng-model=\"user.password\" required=\"\"><div ng-show=\"loginForm.password.$dirty\" ng-messages=\"loginForm.password.$error\"><div ng-message=\"required\">Password is required</div></div></md-input-container><div ng-show=\"vm.wrongCredentials\">The email and password you entered don\'t match.</div><md-card-actions layout=\"column\" layout-align=\"center center\"><md-button ng-disabled=\"registerForm.$invalid || vm.isRegistering()\" ng-click=\"vm.register(user)\" class=\"md-raised md-primary\">{{ vm.getRegisterMessage() }}</md-button></md-card-actions><div class=\"\">{{vm.errorMessage}}</div><div class=\"alt-action\"><a flex=\"\" ui-sref=\"k9.login\">Existing User?</a></div></form></md-card></md-content></div></md-content>");
$templateCache.put("app/reports/reports.tmpl.html","<md-toolbar ng-show=\"!vm.searchActive\"><div class=\"md-toolbar-tools\"><md-button ng-click=\"vm.toggleLeft()\" hide-gt-md=\"\" class=\"md-icon-button\" aria-label=\"Menu\"><ng-md-icon icon=\"menu\" size=\"24\"></ng-md-icon></md-button><h2><span>Reports</span></h2><span flex=\"\"></span></div></md-toolbar><md-toolbar ng-show=\"vm.searchActive\"><div class=\"md-toolbar-tools\"><md-button type=\"button\" class=\"md-icon-button\" ng-click=\"vm.toggleSearch(false)\" aria-label=\"Back\"><md-tooltip md-direction=\"bottom\">Back</md-tooltip><ng-md-icon icon=\"arrow_back\" size=\"24\"></ng-md-icon></md-button><h3 flex=\"10\">Back</h3></div></md-toolbar><md-content flex=\"\" id=\"content\" class=\"report-list\"><md-card><md-card-content><form><p>Choose Report:</p><div layout=\"row\"><div flex=\"\"><md-radio-group ng-model=\"vm.report.reportType\"><md-radio-button value=\"Appointment\" class=\"md-primary\">Appointments</md-radio-button><md-radio-button value=\"Client\" class=\"md-primary\">Clients</md-radio-button><md-radio-button value=\"Dog\" class=\"md-primary\">Dog</md-radio-button></md-radio-group></div><div flex=\"\"><div class=\"icon-holder\"><span class=\"report-heading\">{{ vm.iconReportTitle(vm.report.reportType) }}</span> <img src=\"app/assets/img/report_icon.png\"></div></div></div><div layout=\"row\"><md-button class=\"md-raised md-primary\" ng-disabled=\"vm.isCreatingReport\" ng-click=\"vm.showReport(vm.report.reportType)\">{{ vm.createReportBtnLabel }}</md-button><md-progress-circular ng-show=\"vm.isCreatingReport\" md-mode=\"indeterminate\"></md-progress-circular></div></form></md-card-content></md-card></md-content>");
$templateCache.put("app/settings/settings.tmpl.html","<md-toolbar ng-show=\"!vm.searchActive\"><div class=\"md-toolbar-tools\"><md-button ng-click=\"vm.toggleLeft()\" hide-gt-md=\"\" class=\"md-icon-button\" aria-label=\"Menu\"><ng-md-icon icon=\"menu\" size=\"24\"></ng-md-icon></md-button><h2><span>Settings</span></h2><span flex=\"\"></span></div></md-toolbar><md-toolbar ng-show=\"vm.searchActive\"><div class=\"md-toolbar-tools\"><md-button type=\"button\" class=\"md-icon-button\" ng-click=\"vm.toggleSearch(false)\" aria-label=\"Back\"><md-tooltip md-direction=\"bottom\">Back</md-tooltip><ng-md-icon icon=\"arrow_back\" size=\"24\"></ng-md-icon></md-button><h3 flex=\"10\">Back</h3></div></md-toolbar><md-content flex=\"\" id=\"content\"><md-content ng-cloak=\"\"><md-tabs md-selected=\"vm.selectedTab\" md-dynamic-height=\"\"><md-tab label=\"Breeds\" ui-sref=\"k9.settings.breeds\"><div ui-view=\"breeds\" class=\"view-port-list\"></div></md-tab><md-tab label=\"Activities\" ui-sref=\"k9.settings.activities\"><div ui-view=\"activities\"></div></md-tab></md-tabs></md-content></md-content>");
$templateCache.put("app/social/social.tmpl.html","<md-toolbar ng-show=\"!vm.searchActive\"><div class=\"md-toolbar-tools\"><md-button ng-click=\"vm.toggleLeft()\" hide-gt-md=\"\" class=\"md-icon-button\" aria-label=\"Menu\"><ng-md-icon ng-click=\"vm.clickIconMorph()\" icon=\"{{ vm.clickIcon }}\" options=\'{ \"easing\": \"quad-out\", \"duration\": 500 }\' size=\"24\"></ng-md-icon></md-button><h2><span>Social Media</span></h2><span flex=\"\"></span></div></md-toolbar><md-toolbar ng-show=\"vm.searchActive\"><div class=\"md-toolbar-tools\"><md-button type=\"button\" class=\"md-icon-button\" ng-click=\"vm.toggleSearch(false)\" aria-label=\"Back\"><md-tooltip md-direction=\"bottom\">Back</md-tooltip><ng-md-icon icon=\"arrow_back\" size=\"24\"></ng-md-icon></md-button><h3 flex=\"10\">Back</h3></div></md-toolbar><md-content flex=\"\" id=\"content\"><md-card><md-card-title><md-card-title-text><span class=\"md-headline\">Campaign Manager</span></md-card-title-text></md-card-title><md-card-content><img src=\"http://i.imgur.com/nDn0Aqa.jpg\"><p>This section will allow you to create new social Media activities such as Facebook posts to share photos of newly groomed dogs and help advertise your business (WIP)</p></md-card-content></md-card></md-content><button class=\"md-fab md-fab-bottom-right md-button md-default-theme\" aria-label=\"Add\" tabindex=\"0\"><ng-md-icon icon=\"add\" size=\"24\"></ng-md-icon><md-tooltip>Add New Campaign</md-tooltip></button>");
$templateCache.put("app/activities/create/activity-create.tmpl.html","<form role=\"form\" name=\"add-activity-form\" ng-submit=\"vm.createActivity(newActivity)\"><md-toolbar><div class=\"md-toolbar-tools\"><md-button ui-sref=\"k9.activities\" class=\"md-icon-button\" aria-label=\"Go Back\"><md-tooltip md-direction=\"bottom\">Go back</md-tooltip><ng-md-icon icon=\"keyboard_backspace\" size=\"24\"></ng-md-icon></md-button><h2><span>New Activity</span></h2><span flex=\"\"></span><md-button type=\"submit\" class=\"md-icon-button\" aria-label=\"Save Activity\"><md-tooltip md-direction=\"bottom\">Save Activity</md-tooltip><ng-md-icon icon=\"done\" size=\"24\"></ng-md-icon></md-button></div></md-toolbar><md-content flex=\"\" class=\"md-padding\"><div layout=\"\" layout-xs=\"column\"><md-input-container flex=\"\"><label>Description</label> <input ng-model=\"newActivity.description\" ng-required=\"true\" rm-focus=\"\"><div ng-show=\"add-activity-form.descripton.$dirty\" ng-messages=\"add-activity-form.descripton.$error\"><div ng-message=\"required\">A description must be entered</div></div></md-input-container></div></md-content></form>");
$templateCache.put("app/activities/edit/activity-edit.tmpl.html","<form role=\"form\" name=\"update-activity-form\" ng-submit=\"vm.updateActivity(vm.editedActivity)\"><md-toolbar><div class=\"md-toolbar-tools\"><md-button ui-sref=\"k9.settings.activities\" class=\"md-icon-button\" aria-label=\"Go Back\"><md-tooltip md-direction=\"bottom\">Go back</md-tooltip><ng-md-icon ng-click=\"vm.clickIconMorph()\" icon=\"{{vm.clickIcon}}\" options=\'{ \"easing\": \"quad-in\", \"duration\": 500 }\' size=\"24\"></ng-md-icon></md-button><h2><span>Edit Activity</span></h2><span flex=\"\"></span><md-button type=\"button\" class=\"md-icon-button\" aria-label=\"Delete Activity\" ng-click=\"vm.deleteActivity(vm.editedActivity)\"><md-tooltip md-direction=\"bottom\">Delete Activity</md-tooltip><ng-md-icon icon=\"delete\" size=\"24\"></ng-md-icon></md-button><md-button type=\"submit\" class=\"md-icon-button\" aria-label=\"Save Activity\"><md-tooltip md-direction=\"bottom\">Save Activity</md-tooltip><ng-md-icon icon=\"done\" size=\"24\"></ng-md-icon></md-button></div></md-toolbar><md-content flex=\"\" class=\"md-padding\"><div layout=\"column\"><md-input-container flex=\"\"><label>Description</label> <input ng-model=\"vm.editedActivity.description\" ng-required=\"true\" rm-focus=\"\"><div ng-show=\"update-activity-form.description.$dirty\" ng-messages=\"update-activity-form.description.$error\"><div ng-message=\"required\">A description must be entered</div></div></md-input-container><md-input-container flex=\"\"><label>Default Charge</label> <input ng-model=\"vm.editedActivity.default_charge\" type=\"number\" ng-required=\"true\"><div ng-show=\"update-activity-form.description.$dirty\" ng-messages=\"update-activity-form.description.$error\"><div ng-message=\"required\">A default charge must be entered</div></div></md-input-container></div><md-input-container flex=\"\"><md-checkbox ng-model=\"vm.editedActivity.active\" aria-label=\"Active\" ng-true-value=\"true\" ng-false-value=\"false\" flex=\"\">Active</md-checkbox></md-input-container></md-content></form>");
$templateCache.put("app/breeds/create/breed-create.tmpl.html","<form role=\"form\" name=\"add-breed-form\" ng-submit=\"vm.createBreed(newBreed)\"><md-toolbar><div class=\"md-toolbar-tools\"><md-button ui-sref=\"k9.breeds\" class=\"md-icon-button\" aria-label=\"Go Back\"><md-tooltip md-direction=\"bottom\">Go back</md-tooltip><ng-md-icon icon=\"keyboard_backspace\" size=\"24\"></ng-md-icon></md-button><h2><span>New Breed</span></h2><span flex=\"\"></span><md-button type=\"submit\" class=\"md-icon-button\" aria-label=\"Save Breed\"><md-tooltip md-direction=\"bottom\">Save Breed</md-tooltip><ng-md-icon icon=\"done\" size=\"24\"></ng-md-icon></md-button></div></md-toolbar><md-content flex=\"\" class=\"md-padding\"><div layout=\"\" layout-xs=\"column\"><md-input-container flex=\"\"><label>Name</label> <input ng-model=\"newBreed.name\" ng-required=\"true\" rm-focus=\"\"><div ng-show=\"add-breed-form.name.$dirty\" ng-messages=\"add-breed-form.name.$error\"><div ng-message=\"required\">A name must be entered</div></div></md-input-container></div></md-content></form>");
$templateCache.put("app/breeds/edit/breed-edit.tmpl.html","<form role=\"form\" name=\"update-breed-form\" ng-submit=\"vm.updateBreed(vm.editedBreed)\"><md-toolbar><div class=\"md-toolbar-tools\"><md-button ui-sref=\"k9.settings.breeds\" class=\"md-icon-button\" aria-label=\"Go Back\"><md-tooltip md-direction=\"bottom\">Go back</md-tooltip><ng-md-icon ng-click=\"vm.clickIconMorph()\" icon=\"{{vm.clickIcon}}\" options=\'{ \"easing\": \"quad-in\", \"duration\": 500 }\' size=\"24\"></ng-md-icon></md-button><h2><span>Edit Breed</span></h2><span flex=\"\"></span><md-button type=\"button\" class=\"md-icon-button\" aria-label=\"Delete Breed\" ng-click=\"vm.deleteBreed(vm.editedBreed)\"><md-tooltip md-direction=\"bottom\">Delete Breed</md-tooltip><ng-md-icon icon=\"delete\" size=\"24\"></ng-md-icon></md-button><md-button type=\"submit\" class=\"md-icon-button\" aria-label=\"Save Breed\"><md-tooltip md-direction=\"bottom\">Save Breed</md-tooltip><ng-md-icon icon=\"done\" size=\"24\"></ng-md-icon></md-button></div></md-toolbar><md-content flex=\"\" class=\"md-padding\"><div layout=\"\" layout-xs=\"column\"><md-input-container flex=\"\"><label>Name</label> <input ng-model=\"vm.editedBreed.name\" ng-required=\"true\" rm-focus=\"\"><div ng-show=\"update-breed-form.name.$dirty\" ng-messages=\"update-breed-form.name.$error\"><div ng-message=\"required\">A name must be entered</div></div></md-input-container></div></md-content></form>");
$templateCache.put("app/clients/create/client-create.tmpl.html","<form role=\"form\" name=\"add-client-form\" ng-submit=\"vm.createClient(newClient)\"><md-toolbar><div class=\"md-toolbar-tools\"><md-button ui-sref=\"k9.clients\" class=\"md-icon-button\" aria-label=\"Go Back\"><md-tooltip md-direction=\"bottom\">Go back</md-tooltip><ng-md-icon icon=\"keyboard_backspace\" size=\"24\"></ng-md-icon></md-button><h2><span>Clients</span></h2><span flex=\"\"></span><md-progress-circular md-mode=\"indeterminate\" class=\"md-accent\" ng-show=\"vm.isSaving()\"></md-progress-circular><md-button type=\"submit\" class=\"md-icon-button\" aria-label=\"Save Client\" ng-hide=\"vm.isSaving()\"><md-tooltip md-direction=\"bottom\">Save Client</md-tooltip><ng-md-icon icon=\"done\" size=\"24\"></ng-md-icon></md-button></div></md-toolbar><md-content flex=\"\" class=\"md-padding\"><div layout=\"\" layout-xs=\"column\"><md-input-container flex=\"\"><label>First name</label> <input ng-model=\"newClient.firstname\" ng-required=\"true\" rm-focus=\"\"><div ng-show=\"add-client-form.firstName.$dirty\" ng-messages=\"add-client-form.firstName.$error\"><div ng-message=\"required\">A first name must be entered</div></div></md-input-container><md-input-container flex=\"\"><label>Last name</label> <input ng-model=\"newClient.lastname\" ng-required=\"true\" rm-focus=\"\"><div ng-show=\"add-client-form.lastName.$dirty\" ng-messages=\"add-client-form.lastName.$error\"><div ng-message=\"required\">A last name must be entered</div></div></md-input-container></div><div layout=\"\" layout-xs=\"column\"><md-input-container flex=\"\"><label>Phone</label> <input ng-model=\"newClient.phone\"></md-input-container><md-input-container flex=\"\"><label>Email</label> <input ng-model=\"newClient.email\"></md-input-container></div><div layout=\"\" layout-xs=\"column\"><md-input-container flex=\"\"><label>address</label> <textarea name=\"address\" ng-model=\"newClient.address\" md-maxlength=\"100\" places-auto-complete=\"\" size=\"80\" placeholder=\"Type address...\" component-restrictions=\"{country:\'ie\'}\"></textarea></md-input-container></div></md-content></form>");
$templateCache.put("app/clients/edit/client-edit.tmpl.html","<form role=\"form\" name=\"update-client-form\" ng-submit=\"vm.updateClient(vm.editedClient)\"><md-toolbar><div class=\"md-toolbar-tools\"><md-button ng-click=\"vm.viewClient(vm.editedClient)\" class=\"md-icon-button\" aria-label=\"Go Back\"><md-tooltip md-direction=\"bottom\">Go back</md-tooltip><ng-md-icon icon=\"keyboard_backspace\" size=\"24\"></ng-md-icon></md-button><h2><span>Clients</span></h2><span flex=\"\"></span><md-button type=\"button\" class=\"md-icon-button\" aria-label=\"Delete Client\" ng-click=\"vm.deleteClient(vm.editedClient)\"><md-tooltip md-direction=\"bottom\">Delete Client</md-tooltip><ng-md-icon icon=\"delete\" size=\"24\"></ng-md-icon></md-button><md-progress-circular md-mode=\"indeterminate\" class=\"md-accent\" ng-show=\"vm.isSaving()\"></md-progress-circular><md-button type=\"submit\" class=\"md-icon-button\" aria-label=\"Save Client\" ng-hide=\"vm.isSaving()\"><md-tooltip md-direction=\"bottom\">Save Client</md-tooltip><ng-md-icon icon=\"done\" size=\"24\"></ng-md-icon></md-button></div></md-toolbar><md-content flex=\"\" class=\"md-padding\"><div layout=\"\" layout-xs=\"column\"><md-input-container flex=\"\"><div class=\"upload-image-placeholder\"><div class=\"\"><img ngf-thumbnail=\"vm.editedClient.picture\" height=\"100\"> <img ng-src=\"{{ vm.editedClient.picture_thumb_cropped }}\" class=\"md-card-image\" alt=\"Profile Image\" height=\"80\" ng-hide=\"vm.editedClient.picture.name.length > 0\" layout-padding=\"\"></div><div class=\"\"><md-button ngf-select=\"\" ng-model=\"vm.editedClient.picture\" name=\"picture\" ngf-pattern=\"\'image/*\'\" ngf-accept=\"\'image/*\'\" ngf-max-size=\"20MB\" ngf-min-height=\"100\">Change Image</md-button></div></div></md-input-container><md-input-container flex=\"\"><label>First name</label> <input ng-model=\"vm.editedClient.first_name\" ng-required=\"true\" rm-focus=\"\"><div ng-show=\"update-client-form.firstName.$dirty\" ng-messages=\"update-client-form.firstName.$error\"><div ng-message=\"required\">A first name must be entered</div></div></md-input-container><md-input-container flex=\"\"><label>Last name</label> <input ng-model=\"vm.editedClient.last_name\" ng-required=\"true\" rm-focus=\"\"><div ng-show=\"update-client-form.lastName.$dirty\" ng-messages=\"update-client-form.lastName.$error\"><div ng-message=\"required\">A last name must be entered</div></div></md-input-container></div><div layout=\"\" layout-xs=\"column\"><md-input-container flex=\"\"><label>Phone</label> <input ng-model=\"vm.editedClient.phone\"></md-input-container><md-input-container flex=\"\"><label>Email</label> <input ng-model=\"vm.editedClient.email\"></md-input-container></div><div layout=\"\" layout-xs=\"column\"><md-input-container flex=\"\"><label>Address</label> <textarea name=\"address\" ng-model=\"vm.editedClient.address\" md-maxlength=\"100\" places-auto-complete=\"\" size=\"80\" placeholder=\"Type address...\" component-restrictions=\"{country:\'ie\'}\"></textarea></md-input-container></div></md-content></form><div class=\"\"></div>");
$templateCache.put("app/clients/view/client-view.tmpl.html","<md-toolbar class=\"client-view\"><div class=\"md-toolbar-tools\"><md-button ui-sref=\"k9.clients\" class=\"md-icon-button\" aria-label=\"Go Back\"><md-tooltip md-direction=\"bottom\">Go back</md-tooltip><ng-md-icon icon=\"keyboard_backspace\" size=\"24\"></ng-md-icon></md-button><h2><span>{{ vm.client.first_name }} {{ vm.client.last_name }}</span></h2><span flex=\"\"></span><md-button type=\"submit\" class=\"md-icon-button\" aria-label=\"Edit Client\" ng-click=\"vm.editClient(vm.client)\"><md-tooltip md-direction=\"bottom\">Edit Client</md-tooltip><ng-md-icon icon=\"edit\" size=\"24\"></ng-md-icon></md-button></div></md-toolbar><div layout=\"row\" layout-xs=\"column\" class=\"client-view\"><md-card layout=\"column\" flex=\"33\" flex-xs=\"100\"><div class=\"client-profile\"><img ng-src=\"{{ vm.client.picture_thumb_cropped }}\" class=\"md-card-image\" alt=\"Profile Image\" layout-padding=\"\"><div class=\"client-name\"><h3>{{ vm.client.first_name }} {{ vm.client.last_name }}</h3></div></div><md-list class=\"contact-details\"><md-divider ng-show=\"vm.client.phone.length > 0\"></md-divider><md-list-item class=\"md-2-line\" ng-show=\"vm.client.phone.length > 0\"><ng-md-icon icon=\"phone\" size=\"16\" ng-class=\"md-avatar-icon\"></ng-md-icon><div class=\"md-list-item-text\"><h3><a href=\"tel:{{ vm.client.phone }}\">{{ vm.client.phone }}</a></h3><p>home phone</p></div></md-list-item><md-divider ng-show=\"vm.client.email.length > 0\"></md-divider><md-list-item class=\"md-2-line\" ng-show=\"vm.client.email.length > 0\"><ng-md-icon icon=\"email\" size=\"16\" ng-class=\"md-avatar-icon\"></ng-md-icon><div class=\"md-list-item-text\"><h3><a href=\"mailto:{{ vm.client.email }}\">{{ vm.client.email }}</a></h3><p>e-mail</p></div></md-list-item><md-divider ng-show=\"vm.client.address.length > 0\"></md-divider><md-list-item class=\"md-2-line\" ng-show=\"vm.client.address.length > 0\"><ng-md-icon icon=\"home\" size=\"16\" ng-class=\"md-avatar-icon\"></ng-md-icon><div class=\"md-list-item-text\"><span>{{ vm.client.address }}</span><p>address</p></div></md-list-item></md-list></md-card><md-card layout=\"column\" flex=\"66\" flex-xs=\"100\"><md-content ng-cloak=\"\"><md-tabs md-dynamic-height=\"\" md-border-bottom=\"\"><md-tab label=\"Pets ({{ vm.client.dogs.length }})\"><md-content><div class=\"pets-list\"><div ng-show=\"(vm.client.dogs | filter:vm.petSearchText).length < 1\" class=\"alert alert-info text-center\" flex=\"\" layout-padding=\"\" role=\"alert\"><p>There are no pets yet. You can add your first pet by clicking the Add Pet button below.</p></div><div ng-hide=\"(vm.client.dogs | filter:vm.petSearchText).length < 1\"><md-content class=\"search-results\" flex=\"\" layout-padding=\"\"><md-list-item class=\"pet-list\" ng-click=\"vm.editPet(pet)\" ng-repeat=\"pet in vm.client.dogs | filter:vm.petSearchText\"><img ng-src=\"{{ pet.photos[pet.photos.length - 1].thumbnail_menu }}\" class=\"thumb\" alt=\"{{ photo.title }}\" aria-label=\"{{ photo.title }}\" ng-show=\"pet.photos.length > 0\" layout-padding=\"\"><div><h3>{{ pet.name }}</h3><ul class=\"pet-meta\"><li ng-show=\"pet.breed.name.length > 0\"><strong>Breed:</strong> {{ pet.breed.name }}</li><li><strong>Total Photos:</strong> {{ pet.photos.length }}</li></ul></div></md-list-item></md-content></div></div><button class=\"md-button md-default-theme\" aria-label=\"Add\" tabindex=\"0\" ng-click=\"vm.createPet(this)\"><ng-md-icon icon=\"add\" size=\"24\"></ng-md-icon><md-tooltip>Add Pet</md-tooltip>Add Pet</button></md-content></md-tab><md-tab label=\"Appointments ({{ vm.appointments.length }})\"><md-content><section><md-subheader class=\"md-primary\">Upcoming Appointments</md-subheader><md-list layout-padding=\"\"><md-list-item class=\"md-3-line\" ng-repeat=\"appointment in vm.appointments\"><ng-md-icon icon=\"schedule\" class=\"md-avatar\" size=\"28\"></ng-md-icon><div class=\"md-list-item-text\"><h3>{{appointment.title}}</h3><h4>{{appointment.dog.name}} - {{ appointment.start_at | date : \'MMM d\' }}, {{ appointment.start_at | date : \'hh:mm\' }}</h4><p>{{appointment.activity.description}}</p></div></md-list-item></md-list></section><button class=\"md-button md-default-theme\" aria-label=\"Add\" tabindex=\"0\" ng-click=\"vm.addAppointment(this)\"><ng-md-icon icon=\"add\" size=\"24\"></ng-md-icon><md-tooltip>Add Pet</md-tooltip>Add Appointment</button></md-content></md-tab><md-tab label=\"Photos\"><div ng-show=\"vm.client.dogs.length < 1\"><md-content class=\"layout-padding\">No pet images are currently available</md-content></div><div ng-repeat=\"dog in vm.client.dogs\" class=\"md-padding\"><h4><a ui-sref=\"k9.pets.edit({petID: dog.id})\">{{dog.name}}</a></h4><md-content flex=\"\"><md-grid-list md-cols=\"1\" md-cols-sm=\"2\" md-cols-md=\"3\" md-cols-gt-md=\"6\" md-row-height-gt-md=\"1:1\" md-row-height=\"4:3\" md-gutter=\"8px\" md-gutter-gt-sm=\"4px\"><md-grid-tile ng-repeat=\"photo in dog.photos\" md-rowspan=\"1\" md-colspan=\"1\" md-colspan-sm=\"1\" md-colspan-xs=\"1\"><img ng-src=\"{{ photo.thumbnail_medium }}\" ng-click=\"vm.selectPhoto(photo)\" class=\"md-card-image\" alt=\"{{ photo.title }}\" aria-label=\"{{ photo.title }}\" layout-padding=\"\"><md-grid-tile-footer><h3>{{ photo.title }}</h3></md-grid-tile-footer></md-grid-tile></md-grid-list></md-content></div></md-tab></md-tabs></md-content></md-card></div>");
$templateCache.put("app/components/navbar/navbar.html","<nav class=\"navbar navbar-static-top navbar-inverse\"><div class=\"container-fluid\"><div class=\"navbar-header\"><a class=\"navbar-brand\" ui-sref=\"k9\"><span class=\"glyphicon glyphicon-home\"></span> K9: Groomer Management</a></div><div class=\"collapse navbar-collapse\" id=\"bs-example-navbar-collapse-6\"><ul class=\"nav navbar-nav\"><li class=\"active\"><a ui-sref=\"k9\">Home</a></li><li><a ui-sref=\"k9.clients\">Clients</a></li><li><span class=\"glyphicon glyphicon-home\"></span> Application was created {{ vm.relativeDate }}</li></ul></div></div></nav>");
$templateCache.put("app/dashboard/create/appointment-create.tmpl.html","<md-dialog flex=\"50\" class=\"appointmentDialog\" aria-label=\"Create Appointment\" ng-cloak=\"\"><form role=\"form\" name=\"add-appointment-form\" ng-submit=\"vm.createAppointment(vm.newAppointment)\"><md-toolbar><div class=\"md-toolbar-tools\"><md-button class=\"md-icon-button\" ng-click=\"vm.createAppointmentCancel()\"><ng-md-icon icon=\"close\" size=\"24\"></ng-md-icon><md-tooltip md-direction=\"bottom\">Cancel and Close</md-tooltip></md-button><h2><span ng-hide=\"vm.newAppointment.id\">Create</span> <span ng-show=\"vm.newAppointment.id\">Edit</span> <span hide-xs=\"\">Appointment</span></h2><span flex=\"\"></span><md-button type=\"button\" class=\"md-icon-button\" aria-label=\"Delete Client\" ng-show=\"vm.newAppointment.id && vm.newAppointment.id > 0\" ng-click=\"vm.deleteAppointment(vm.newAppointment)\"><md-tooltip md-direction=\"bottom\">Delete Appointment</md-tooltip><ng-md-icon icon=\"delete\" size=\"24\"></ng-md-icon></md-button><md-progress-circular md-mode=\"indeterminate\" class=\"md-accent\" ng-show=\"vm.isSaving()\"></md-progress-circular><md-button type=\"submit\" class=\"md-icon-button\" aria-label=\"Save\" ng-hide=\"vm.isSaving()\"><ng-md-icon icon=\"done\" size=\"24\"></ng-md-icon><md-tooltip md-direction=\"bottom\">Save</md-tooltip></md-button></div></md-toolbar><md-dialog-content><div class=\"md-dialog-content\"><md-input-container class=\"md-block\"><label>Title</label> <input ng-model=\"vm.newAppointment.title\" ng-required=\"true\" rm-focus=\"\"></md-input-container><md-autocomplete required=\"\" md-input-name=\"autocompleteField\" md-input-minlength=\"2\" md-input-maxlength=\"18\" md-no-cache=\"vm.noCache\" md-selected-item=\"vm.newAppointment.dog\" md-search-text=\"vm.searchText\" md-items=\"item in vm.querySearch(vm.searchText)\" md-item-text=\"item.name\" md-floating-label=\"Pet\'s name\" ng-required=\"true\"><md-item-template><span md-highlight-text=\"vm.searchText\">{{item.name}}</span></md-item-template><div ng-messages=\"searchForm.autocompleteField.$error\" ng-if=\"searchForm.autocompleteField.$touched\"><div ng-message=\"required\">You <b>must</b> enter a pet.</div><div ng-message=\"minlength\">Your entry is not long enough.</div><div ng-message=\"maxlength\">Your entry is too long.</div></div></md-autocomplete><div layout=\"row\" layout-sm=\"column\"><md-input-container class=\"md-block\" flex=\"\"><label>Job</label><md-select md-on-close=\"vm.activityChanged(vm.newAppointment.activity.id)\" ng-model=\"vm.newAppointment.activity.id\"><md-option ng-repeat=\"activity in vm.activities\" value=\"{{activity.id}}\">{{activity.description}}</md-option></md-select></md-input-container><md-input-container class=\"md-block\" flex=\"\"><label>Charge</label> <input ng-model=\"vm.newAppointment.charge\" type=\"number\" step=\"5\"></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\"><div flex=\"\"><md-datepicker ng-model=\"vm.newAppointment.start\" ng-required=\"true\" md-placeholder=\"Date\"></md-datepicker></div><div flex=\"\"><md-input-container><label>Time</label><md-select ng-model=\"vm.newAppointment.startTime\" ng-model-options=\"{trackBy: \'$value.id\'}\" ng-required=\"true\" aria-label=\"Appointment Start Time\"><md-option ng-value=\"time\" ng-repeat=\"time in vm.bookingTimes\">{{ time.name }}</md-option></md-select></md-input-container></div></div><div class=\"\"><md-checkbox flex=\"\" ng-model=\"vm.newAppointment.sendEmailConfirmation\" aria-label=\"Send Email Confirmation\">Send E-mail Confirmation</md-checkbox></div><div layout=\"row\" layout-xs=\"column\" ng-show=\"vm.newAppointment.id\"><div flex=\"\"><md-button layout-fill=\"\" flex=\"\" ng-click=\"vm.printReceipt(vm.newAppointment)\" ng-disabled=\"vm.isSaving()\" aria-label=\"Print Receipt\">Print Receipt</md-button></div><div flex=\"\"><md-button layout-fill=\"\" flex=\"\" ng-click=\"vm.sendSMSReminder(vm.newAppointment.id)\" aria-label=\"Send SMS Pick-up Reminder\" ng-disabled=\"vm.smsSendingDisabled()\">{{ vm.getSMSButtonText() }}</md-button></div></div></div></md-dialog-content></form></md-dialog>");
$templateCache.put("app/pets/create/pet-create.tmpl.html","<md-toolbar><div class=\"md-toolbar-tools\"><md-button ui-sref=\"k9.pets\" class=\"md-icon-button\" aria-label=\"Go Back\"><md-tooltip md-direction=\"bottom\">Go back</md-tooltip><ng-md-icon icon=\"keyboard_backspace\" size=\"24\"></ng-md-icon></md-button><h2><span>New Pet</span></h2><span flex=\"\"></span><md-progress-circular md-mode=\"indeterminate\" class=\"md-accent\" ng-show=\"vm.isSaving()\"></md-progress-circular><md-button type=\"button\" class=\"md-icon-button\" aria-label=\"Save Pet\" ng-click=\"vm.createPet(newPet)\" ng-hide=\"vm.isSaving()\"><md-tooltip md-direction=\"bottom\">Save Pet</md-tooltip><ng-md-icon icon=\"done\" size=\"24\"></ng-md-icon></md-button></div></md-toolbar><md-content class=\"pet-create md-padding\" flex=\"\"><form role=\"form\" name=\"add-pet-form\" ng-submit=\"vm.createPet(newPet)\"><div layout=\"\" layout-xs=\"column\"><md-input-container flex=\"\"><label>Name</label> <input ng-model=\"newPet.name\" ng-required=\"true\" rm-focus=\"\"><div ng-show=\"update-pet-form.name.$dirty\" ng-messages=\"update-pet-form.name.$error\"><div ng-message=\"required\">A name must be entered</div></div></md-input-container><md-input-container flex=\"\"><label>Breed</label><md-select ng-model=\"newPet.breed.id\"><md-option ng-repeat=\"breed in vm.breeds\" value=\"{{breed.id}}\">{{breed.name}}</md-option></md-select></md-input-container></div><div layout=\"\" layout-xs=\"column\"><md-input-container flex=\"\"><label>Note</label> <textarea name=\"note\" ng-model=\"newPet.note\" md-maxlength=\"100\"></textarea></md-input-container></div></form></md-content>");
$templateCache.put("app/pets/edit/pet-edit.tmpl.html","<md-toolbar><div class=\"md-toolbar-tools\"><md-button ng-click=\"vm.goBack();\" class=\"md-icon-button\" aria-label=\"Go Back\"><md-tooltip md-direction=\"bottom\">Go back</md-tooltip><ng-md-icon ng-click=\"vm.clickIconMorph()\" icon=\"{{vm.clickIcon}}\" options=\'{ \"easing\": \"quad-in\", \"duration\": 500 }\' size=\"24\"></ng-md-icon></md-button><h2><span>Edit Pet</span></h2><span flex=\"\"></span><md-button type=\"button\" class=\"md-icon-button\" aria-label=\"Delete Pet\" ng-click=\"vm.deletePet(vm.editedPet)\"><md-tooltip md-direction=\"bottom\">Delete Pet</md-tooltip><ng-md-icon icon=\"delete\" size=\"24\"></ng-md-icon></md-button><md-button type=\"button\" ng-click=\"vm.updatePet(vm.editedPet)\" class=\"md-icon-button\" aria-label=\"Save Pet\"><md-tooltip md-direction=\"bottom\">Save Pet</md-tooltip><ng-md-icon icon=\"done\" size=\"24\"></ng-md-icon></md-button></div></md-toolbar><md-content class=\"pet-edit\" ng-cloak=\"\"><md-tabs md-dynamic-height=\"\"><md-tab label=\"Main\"><md-content flex=\"\" class=\"md-padding\"><form role=\"form\" name=\"update-pet-form\" ng-submit=\"vm.updatePet(vm.editedPet)\"><div layout=\"\" layout-xs=\"column\"><md-input-container flex=\"\"><label>Name</label> <input ng-model=\"vm.editedPet.name\" ng-required=\"true\" rm-focus=\"\"><div ng-show=\"update-pet-form.name.$dirty\" ng-messages=\"update-pet-form.name.$error\"><div ng-message=\"required\">A name must be entered</div></div></md-input-container><md-input-container flex=\"\"><label>Breed</label><md-select ng-model=\"vm.editedPet.breed.id\"><md-option ng-repeat=\"breed in vm.breeds\" value=\"{{breed.id}}\">{{breed.name}}</md-option></md-select></md-input-container></div><div layout=\"\" layout-xs=\"column\"><md-input-container flex=\"\"><label>Note</label> <textarea name=\"note\" ng-model=\"vm.editedPet.note\" md-maxlength=\"100\"></textarea></md-input-container></div></form></md-content></md-tab><md-tab label=\"Photos ({{ vm.editedPet.photos.length }})\"><md-content flex=\"\" class=\"md-padding\"><md-grid-list md-cols=\"1\" md-cols-sm=\"2\" md-cols-md=\"3\" md-cols-gt-md=\"6\" md-row-height-gt-md=\"1:1\" md-row-height=\"4:3\" md-gutter=\"8px\" md-gutter-gt-sm=\"4px\"><md-grid-tile ng-repeat=\"photo in vm.editedPet.photos\" md-rowspan=\"1\" md-colspan=\"1\" md-colspan-sm=\"1\" md-colspan-xs=\"1\"><md-button class=\"remove-photo md-fab md-mini\" ng-click=\"vm.removePetImage(photo)\">X</md-button><img ng-src=\"{{ photo.thumbnail_medium }}\" ng-click=\"vm.selectPhoto(photo)\" class=\"md-card-image\" alt=\"{{ photo.title }}\" aria-label=\"{{ photo.title }}\" layout-padding=\"\"><md-grid-tile-footer><h3>{{ photo.title }}</h3></md-grid-tile-footer></md-grid-tile></md-grid-list></md-content><md-content flex=\"\" class=\"md-padding\"><md-whiteframe ng-show=\"vm.selectedPhoto !== null\"><md-content layout-padding=\"\"><form name=\"editPhotoDetailsForm\"><h2>Edit Photo Details</h2><div layout=\"row\"><md-input-container flex=\"\"><label>Title</label> <input ng-model=\"vm.selectedPhoto.title\" ng-required=\"true\"><div ng-show=\"add-photo-form.name.$dirty\" ng-messages=\"add-photo-form.name.$error\"><div ng-message=\"required\">A title must be entered</div></div></md-input-container><div flex=\"\"><md-button ng-click=\"vm.selectPhoto(null)\">Cancel</md-button><md-button ng-disabled=\"!editPhotoDetailsForm.$valid\" ng-click=\"vm.updatePhotoDetails(vm.selectedPhoto)\" class=\"md-raised md-primary\">Update Photo Details</md-button></div></div></form></md-content></md-whiteframe><md-content ng-hide=\"vm.uploadingImage\" layout-padding=\"\"><md-button ng-click=\"vm.toggleUploadForm(true)\">Add New Photo</md-button></md-content><md-content ng-show=\"vm.uploadingImage\" layout-padding=\"\"><form name=\"editPetAddPhotoForm\"><h2>Add New Photo</h2><md-progress-linear md-mode=\"determinate\" ng-show=\"{{ vm.newphoto.file.progress >= 0 }}\" value=\"{{vm.newphoto.file.progress}}\"></md-progress-linear><div layout=\"column\"><md-input-container flex=\"\"><md-button class=\"md-raised\" type=\"file\" ngf-select=\"\" ng-model=\"vm.newphoto.file\" name=\"file\" ngf-accept=\"\'image/*\'\" ngf-change=\"alert(\'whats up\')\" required=\"\">Select Photo</md-button></md-input-container><md-input-container flex=\"\"><label>Title</label> <input ng-model=\"vm.newphoto.title\" ng-required=\"true\"><div ng-show=\"add-photo-form.name.$dirty\" ng-messages=\"add-photo-form.name.$error\"><div ng-message=\"required\">A title must be entered</div></div></md-input-container><div layout=\"row\"><md-datepicker ng-model=\"vm.newphoto.dateTaken\"></md-datepicker></div><div layout=\"row\"><md-input-container flex=\"\"><a href=\"#\" ng-click=\"vm.toggleUploadForm(false)\">Cancel</a><md-button ng-disabled=\"!editPetAddPhotoForm.$valid || vm.isUploading\" ng-click=\"vm.uploadPetImage(vm.newphoto)\" class=\"md-raised md-primary\">{{ vm.uploadButtonText }}</md-button></md-input-container><div flex=\"\"><md-progress-circular ng-show=\"vm.isUploading\" md-mode=\"indeterminate\"></md-progress-circular></div><div flex=\"\"><img ngf-src=\"vm.newphoto.file\" class=\"thumb\"> <span ng-show=\"vm.newphoto.file.result\">Upload Successful</span></div></div></div></form></md-content></md-content></md-tab></md-tabs></md-content>");
$templateCache.put("app/settings/breeds/settings-breeds.tmpl.html","<k9-full-page-loader ng-show=\"vm.isLoading()\"></k9-full-page-loader><md-content flex=\"\" id=\"content\"><div class=\"breeds-list\"><div ng-show=\"(vm.breeds | filter:vm.breedSearchText).length < 1\" class=\"alert alert-info text-center\" role=\"alert\"><p>There are no breeds yet. You can add your first breed by clicking the Add Breed button below.</p></div><div ng-hide=\"(vm.breeds | filter:vm.breedSearchText).length < 1\"><md-content flex=\"\" layout-padding=\"\"><md-list-item ng-click=\"vm.editBreed(breed)\" ng-repeat=\"breed in vm.breeds | filter:vm.breedSearchText\"><ng-md-icon icon=\"paw\" size=\"24\"></ng-md-icon><p>{{ breed.name }}</p><ng-md-icon icon=\"chevron_right\" size=\"24\"></ng-md-icon></md-list-item></md-content></div></div></md-content><button class=\"md-fab md-fab-bottom-right md-button md-default-theme\" ui-sref=\"k9.breeds.create\" aria-label=\"Add\" tabindex=\"0\"><ng-md-icon icon=\"add\" size=\"24\"></ng-md-icon><md-tooltip>Add Breed</md-tooltip></button>");
$templateCache.put("app/settings/activity/settings-activity.tmpl.html","<k9-full-page-loader ng-show=\"vm.isLoading()\"></k9-full-page-loader><md-content flex=\"\" id=\"content\" class=\"view-port-list\"><div class=\"activities-list\"><div ng-show=\"(vm.activities | filter:vm.activitySearchText).length < 1\" class=\"alert alert-info text-center\" role=\"alert\"><p>There are no activities yet. You can add your first activity by clicking the Add Activity button below.</p></div><div ng-hide=\"(vm.activities | filter:vm.activitySearchText).length < 1\"><md-content class=\"search-results\" flex=\"\" layout-padding=\"\"><md-list-item ng-click=\"vm.editActivity(activity)\" ng-repeat=\"activity in vm.activities | filter:vm.activitySearchText\"><ng-md-icon icon=\"paw\" size=\"24\"></ng-md-icon><p>{{ activity.description }}</p><ng-md-icon icon=\"chevron_right\" size=\"24\"></ng-md-icon></md-list-item></md-content></div></div></md-content><button class=\"md-fab md-fab-bottom-right md-button md-default-theme\" ui-sref=\"k9.activities.create\" aria-label=\"Add\" tabindex=\"0\"><ng-md-icon icon=\"add\" size=\"24\"></ng-md-icon><md-tooltip>Add Activity</md-tooltip></button>");
$templateCache.put("app/activities/create/pop/activity-create-pop.tmpl.html","<md-dialog class=\"petDialog\" aria-label=\"Create Pet\" ng-cloak=\"\"><form role=\"form\" name=\"add-pet-form\" ng-submit=\"vm.createPet(vm.newPet)\"><md-toolbar><div class=\"md-toolbar-tools\"><md-button class=\"md-icon-button\" ng-click=\"vm.createPetCancel()\"><ng-md-icon icon=\"close\" size=\"24\"></ng-md-icon><md-tooltip md-direction=\"bottom\">Cancel and Close</md-tooltip></md-button><h2>Create Pet</h2><span flex=\"\"></span><md-button type=\"submit\" class=\"md-icon-button\" aria-label=\"Save\"><ng-md-icon icon=\"done\" size=\"24\"></ng-md-icon><md-tooltip md-direction=\"bottom\">Save</md-tooltip></md-button></div></md-toolbar><md-dialog-content><div class=\"md-dialog-content\"><md-input-container class=\"md-block\"><label>Name</label> <input ng-model=\"vm.newPet.name\" ng-required=\"true\" rm-focus=\"\"></md-input-container></div></md-dialog-content></form></md-dialog>");
$templateCache.put("app/breeds/create/pop/breed-create-pop.tmpl.html","<md-dialog class=\"petDialog\" aria-label=\"Create Pet\" ng-cloak=\"\"><form role=\"form\" name=\"add-pet-form\" ng-submit=\"vm.createPet(vm.newPet)\"><md-toolbar><div class=\"md-toolbar-tools\"><md-button class=\"md-icon-button\" ng-click=\"vm.createPetCancel()\"><ng-md-icon icon=\"close\" size=\"24\"></ng-md-icon><md-tooltip md-direction=\"bottom\">Cancel and Close</md-tooltip></md-button><h2>Create Pet</h2><span flex=\"\"></span><md-button type=\"submit\" class=\"md-icon-button\" aria-label=\"Save\"><ng-md-icon icon=\"done\" size=\"24\"></ng-md-icon><md-tooltip md-direction=\"bottom\">Save</md-tooltip></md-button></div></md-toolbar><md-dialog-content><div class=\"md-dialog-content\"><md-input-container class=\"md-block\"><label>Name</label> <input ng-model=\"vm.newPet.name\" ng-required=\"true\" rm-focus=\"\"></md-input-container></div></md-dialog-content></form></md-dialog>");
$templateCache.put("app/common/directives/client-thumbnail/client-thumbnail.tmpl.html","<div class=\"blank_list_thumb\" ng-hide=\"client.thumbnail_menu.length > 0\"><span>{{ client.initials }}</span></div><img ng-src=\"{{ client.thumbnail_menu }}\" class=\"md-card-image\" alt=\"{{ photo.title }}\" aria-label=\"{{ photo.title }}\" ng-show=\"client.thumbnail_menu.length > 0\" layout-padding=\"\">");
$templateCache.put("app/common/directives/full-page-loader/fullpage-loader.tmpl.html","<div layout=\"column\" layout-fill=\"\" layout-align=\"center center\"><div><md-progress-circular class=\"md-primary\" md-mode=\"indeterminate\" md-diameter=\"70\" style=\"display:inline-block\"></md-progress-circular></div><p class=\"full-page-loader\">Loading. Please wait...</p></div>");
$templateCache.put("app/pets/create/pop/pet-create-pop.tmpl.html","<md-dialog flex=\"50\" class=\"petDialog\" aria-label=\"Create Pet\" ng-cloak=\"\"><form role=\"form\" name=\"add-pet-form\" ng-submit=\"vm.createPet(vm.newPet)\"><md-toolbar><div class=\"md-toolbar-tools\"><md-button class=\"md-icon-button\" ng-click=\"vm.createPetCancel()\"><ng-md-icon icon=\"close\" size=\"24\"></ng-md-icon><md-tooltip md-direction=\"bottom\">Cancel and Close</md-tooltip></md-button><h2>Create Pet</h2><span flex=\"\"></span><md-progress-circular md-mode=\"indeterminate\" class=\"md-accent\" ng-show=\"vm.isSaving()\"></md-progress-circular><md-button type=\"submit\" class=\"md-icon-button\" aria-label=\"Save\" ng-hide=\"vm.isSaving()\"><ng-md-icon icon=\"done\" size=\"24\"></ng-md-icon><md-tooltip md-direction=\"bottom\">Save</md-tooltip></md-button></div></md-toolbar><md-dialog-content class=\"md-padding\"><div layout=\"\" layout-xs=\"column\"><md-input-container flex=\"\"><label>Name</label> <input ng-model=\"vm.newPet.name\" ng-required=\"true\" rm-focus=\"\"><div ng-show=\"update-pet-form.name.$dirty\" ng-messages=\"update-pet-form.name.$error\"><div ng-message=\"required\">A name must be entered</div></div></md-input-container><md-input-container flex=\"\"><label>Breed</label><md-select ng-model=\"vm.newPet.breed.id\"><md-option ng-repeat=\"breed in vm.breeds\" value=\"{{breed.id}}\">{{breed.name}}</md-option></md-select></md-input-container></div><div layout=\"\" layout-xs=\"column\"><md-input-container flex=\"\"><label>Note</label> <textarea name=\"note\" ng-model=\"vm.newPet.note\" md-maxlength=\"100\"></textarea></md-input-container></div></md-dialog-content></form></md-dialog>");}]);